window.CHARM_TAXONOMY_TERMS = [
    {
        "name":  "Zvířata a mazlíčci",
        "key":  "motiv:zvirata",
        "group":  "overall_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zvíře",
                         "zvířata",
                         "mazlíček",
                         "mazlíčci",
                         "animal",
                         "animals",
                         "pet",
                         "pets"
                     ],
        "filterable":  true
    },
    {
        "name":  "Jídlo a nápoje",
        "key":  "motiv:gastro",
        "group":  "overall_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "jídlo",
                         "pití",
                         "nápoj",
                         "nápoje",
                         "food",
                         "drink",
                         "drinks"
                     ],
        "filterable":  true
    },
    {
        "name":  "Příroda a vesmír",
        "key":  "motiv:priroda",
        "group":  "overall_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "příroda",
                         "vesmír",
                         "nature",
                         "space",
                         "universe"
                     ],
        "filterable":  true
    },
    {
        "name":  "Cestování, místa a kultura",
        "key":  "motiv:cestovani",
        "group":  "overall_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "cestování",
                         "cestování po světě",
                         "výlet",
                         "dovolená",
                         "travel",
                         "travelling",
                         "trip",
                         "vacation",
                         "holiday"
                     ],
        "filterable":  true
    },
    {
        "name":  "Móda a styl",
        "key":  "motiv:moda",
        "group":  "overall_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "móda",
                         "styl",
                         "fashion",
                         "style"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hry a zábava",
        "key":  "motiv:hry",
        "group":  "overall_motif",
        "overall_key":  "motiv:hry",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hra",
                         "hry",
                         "zábava",
                         "game",
                         "games",
                         "gaming"
                     ],
        "filterable":  true
    },
    {
        "name":  "Sport a pohyb",
        "key":  "motiv:sport",
        "group":  "overall_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "sport",
                         "sporty",
                         "pohyb",
                         "fitness",
                         "exercise"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hobby a tvoření",
        "key":  "motiv:hobby",
        "group":  "overall_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hobby",
                         "koníček",
                         "koníčky",
                         "tvoření",
                         "kreativita",
                         "hobbies",
                         "creative",
                         "creativity",
                         "crafting"
                     ],
        "filterable":  true
    },
    {
        "name":  "Věda, zdraví a povolání",
        "key":  "motiv:veda-a-povolani",
        "group":  "overall_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "věda",
                         "povolání",
                         "práce",
                         "profese",
                         "science",
                         "profession",
                         "career",
                         "job"
                     ],
        "filterable":  true
    },
    {
        "name":  "Astrologie, duchovno a symboly",
        "key":  "motiv:astrologie-a-symboly",
        "group":  "overall_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "astrologie",
                         "znamení",
                         "duchovno",
                         "symbol",
                         "symboly",
                         "astrology",
                         "zodiac",
                         "spiritual",
                         "spirituality",
                         "symbol",
                         "symbols"
                     ],
        "filterable":  true
    },
    {
        "name":  "Fantazie a příběhy",
        "key":  "motiv:fantazie",
        "group":  "overall_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "fantazie",
                         "pohádka",
                         "pohádky",
                         "fantasy",
                         "fairytale",
                         "fairy tale"
                     ],
        "filterable":  true
    },
    {
        "name":  "Písmena, slova a vzkazy",
        "key":  "motiv:pismena-a-vzkazy",
        "group":  "overall_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "písmeno",
                         "písmena",
                         "iniciála",
                         "iniciály",
                         "slovo",
                         "text",
                         "vzkaz",
                         "letter",
                         "letters",
                         "initial",
                         "initials",
                         "word",
                         "message"
                     ],
        "filterable":  true
    },
    {
        "name":  "Předměty a technika",
        "key":  "motiv:predmety-a-technika",
        "group":  "overall_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "předmět",
                         "předměty",
                         "technika",
                         "objects",
                         "technology",
                         "tech"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hudba",
        "key":  "motiv:hudba",
        "group":  "overall_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hudba",
                         "muzikant",
                         "muzikantka",
                         "musician",
                         "music"
                     ],
        "filterable":  true
    },
    {
        "name":  "Mazlíčci",
        "key":  "motiv:mazlicci",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "mazlíček",
                         "domácí mazlíček",
                         "domácí zvíře",
                         "pet",
                         "pets"
                     ],
        "filterable":  true
    },
    {
        "name":  "Zvířecí symboly",
        "key":  "motiv:zvireci-symboly",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:zvireci-symboly",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zvířecí symbol",
                         "animal symbol",
                         "animal symbols"
                     ],
        "filterable":  true
    },
    {
        "name":  "Potřeby pro mazlíčky",
        "key":  "motiv:potreby-pro-mazlicky",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:potreby-pro-mazlicky",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "potřeby pro zvířata",
                         "pet accessories",
                         "pet supplies"
                     ],
        "filterable":  true
    },
    {
        "name":  "Ptáci",
        "key":  "motiv:ptaci",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pták",
                         "bird",
                         "birds"
                     ],
        "filterable":  true
    },
    {
        "name":  "Vodní zvířata",
        "key":  "motiv:vodni-zvirata",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vodní živočich",
                         "vodní živočichové",
                         "aquatic animal",
                         "aquatic animals",
                         "sea animals"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hmyz",
        "key":  "motiv:hmyz",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:hmyz",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "insect",
                         "insects"
                     ],
        "filterable":  true
    },
    {
        "name":  "Plazi a obojživelníci",
        "key":  "motiv:plazi-a-obojzivelnici",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "plaz",
                         "plazi",
                         "obojživelník",
                         "obojživelníci",
                         "reptile",
                         "reptiles",
                         "amphibian",
                         "amphibians"
                     ],
        "filterable":  true
    },
    {
        "name":  "Divoká a exotická zvířata",
        "key":  "motiv:divoka-a-exoticka-zvirata",
        "group":  "motif_family",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "divoké zvíře",
                         "exotické zvíře",
                         "wild animal",
                         "wild animals",
                         "exotic animal",
                         "exotic animals"
                     ],
        "filterable":  true
    },
    {
        "name":  "Ovoce a zelenina",
        "key":  "motiv:ovoce-a-zelenina",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "ovoce",
                         "zelenina",
                         "fruit",
                         "fruits",
                         "vegetable",
                         "vegetables"
                     ],
        "filterable":  true
    },
    {
        "name":  "Slaná jídla",
        "key":  "motiv:slana-jidla",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "slané jídlo",
                         "slané",
                         "savoury food",
                         "savory food"
                     ],
        "filterable":  true
    },
    {
        "name":  "Dezerty",
        "key":  "motiv:dezerty",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "dezert",
                         "dessert",
                         "desserts"
                     ],
        "filterable":  true
    },
    {
        "name":  "Sladkosti",
        "key":  "motiv:sladkosti",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "sladkost",
                         "cukrovinky",
                         "sweets",
                         "candy"
                     ],
        "filterable":  true
    },
    {
        "name":  "Nápoje",
        "key":  "motiv:napoje",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:napoje",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "nápoj",
                         "pití",
                         "drink",
                         "drinks",
                         "beverage",
                         "beverages"
                     ],
        "filterable":  true
    },
    {
        "name":  "Káva a čaj",
        "key":  "motiv:kava-a-caj",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:kava-a-caj",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "káva",
                         "čaj",
                         "coffee",
                         "tea"
                     ],
        "filterable":  true
    },
    {
        "name":  "Alkoholické nápoje",
        "key":  "motiv:alkoholicke-napoje",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "alkoholický nápoj",
                         "alkohol",
                         "alcoholic drink",
                         "alcoholic drinks"
                     ],
        "filterable":  true
    },
    {
        "name":  "Nádobí a stolování",
        "key":  "motiv:nadobi-a-stolovani",
        "group":  "motif_family",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:nadobi-a-stolovani",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "nádobí",
                         "stolování",
                         "tableware",
                         "dining"
                     ],
        "filterable":  true
    },
    {
        "name":  "Květiny a rostliny",
        "key":  "motiv:kvetiny-a-rostliny",
        "group":  "motif_family",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "květina",
                         "květiny",
                         "rostlina",
                         "rostliny",
                         "flower",
                         "flowers",
                         "plant",
                         "plants"
                     ],
        "filterable":  true
    },
    {
        "name":  "Listy a větvičky",
        "key":  "motiv:listy-a-vetvicky",
        "group":  "motif_family",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:listy-a-vetvicky",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "list",
                         "listy",
                         "větvička",
                         "větvičky",
                         "leaf",
                         "leaves",
                         "branch",
                         "branches"
                     ],
        "filterable":  true
    },
    {
        "name":  "Nebeská tělesa",
        "key":  "motiv:nebeska-telesa",
        "group":  "motif_family",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:nebeska-telesa",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "nebeské těleso",
                         "celestial body",
                         "celestial bodies"
                     ],
        "filterable":  true
    },
    {
        "name":  "Počasí a přírodní jevy",
        "key":  "motiv:pocasi-a-prirodni-jevy",
        "group":  "motif_family",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "počasí",
                         "přírodní jev",
                         "přírodní jevy",
                         "weather",
                         "natural phenomenon",
                         "natural phenomena"
                     ],
        "filterable":  true
    },
    {
        "name":  "Vesmír",
        "key":  "motiv:vesmir",
        "group":  "motif_family",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:vesmir",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kosmos",
                         "space",
                         "outer space",
                         "cosmos"
                     ],
        "filterable":  true
    },
    {
        "name":  "Města a památky",
        "key":  "motiv:mesta-a-pamatky",
        "group":  "motif_family",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:cestovani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "město",
                         "města",
                         "památka",
                         "památky",
                         "city",
                         "cities",
                         "landmark",
                         "landmarks"
                     ],
        "filterable":  true
    },
    {
        "name":  "Doprava a cestování",
        "key":  "motiv:doprava-a-cestovani",
        "group":  "motif_family",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:cestovani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "doprava",
                         "cestování",
                         "transport",
                         "transportation",
                         "travel"
                     ],
        "filterable":  true
    },
    {
        "name":  "Cestovní vzpomínky",
        "key":  "motiv:cestovni-vzpominky",
        "group":  "motif_family",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vzpomínka z cest",
                         "suvenýr",
                         "travel memory",
                         "travel memories",
                         "souvenir"
                     ],
        "filterable":  true
    },
    {
        "name":  "Historie",
        "key":  "motiv:historie",
        "group":  "motif_family",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:historie",
        "fallback_key_1":  "motiv:cestovani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "historický",
                         "historical",
                         "history"
                     ],
        "filterable":  true
    },
    {
        "name":  "Světové kultury",
        "key":  "motiv:svetove-kultury",
        "group":  "motif_family",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:svetove-kultury",
        "fallback_key_1":  "motiv:cestovani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kultura",
                         "kultury",
                         "světová kultura",
                         "culture",
                         "cultures",
                         "world cultures"
                     ],
        "filterable":  true
    },
    {
        "name":  "Módní doplňky",
        "key":  "motiv:modni-doplnky",
        "group":  "motif_family",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:moda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "módní doplněk",
                         "doplněk",
                         "fashion accessory",
                         "fashion accessories"
                     ],
        "filterable":  true
    },
    {
        "name":  "Kabelky",
        "key":  "motiv:kabelky",
        "group":  "motif_family",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:kabelky",
        "fallback_key_1":  "motiv:moda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kabelka",
                         "taška",
                         "handbag",
                         "handbags",
                         "bag",
                         "bags"
                     ],
        "filterable":  true
    },
    {
        "name":  "Obuv",
        "key":  "motiv:obuv",
        "group":  "motif_family",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:obuv",
        "fallback_key_1":  "motiv:moda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "boty",
                         "footwear",
                         "shoes"
                     ],
        "filterable":  true
    },
    {
        "name":  "Společenské hry",
        "key":  "motiv:spolecenske-hry",
        "group":  "motif_family",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "společenská hra",
                         "stolní hra",
                         "desková hra",
                         "tabletop game",
                         "tabletop games",
                         "board game",
                         "board games"
                     ],
        "filterable":  true
    },
    {
        "name":  "Videohry",
        "key":  "motiv:videohry",
        "group":  "motif_family",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:videohry",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "videohra",
                         "video game",
                         "video games",
                         "gaming"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hračky",
        "key":  "motiv:hracky",
        "group":  "motif_family",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:hracky",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hračka",
                         "toy",
                         "toys"
                     ],
        "filterable":  true
    },
    {
        "name":  "Fotografie",
        "key":  "motiv:fotografie",
        "group":  "motif_family",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:fotografie",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "focení",
                         "fotografování",
                         "photography",
                         "photo",
                         "photos"
                     ],
        "filterable":  true
    },
    {
        "name":  "Čtení a psaní",
        "key":  "motiv:cteni-a-psani",
        "group":  "motif_family",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:cteni-a-psani",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "čtení",
                         "psaní",
                         "reading",
                         "writing"
                     ],
        "filterable":  true
    },
    {
        "name":  "Ruční práce",
        "key":  "motiv:rucni-prace",
        "group":  "motif_family",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "ruční tvorba",
                         "tvoření",
                         "handmade",
                         "handicraft",
                         "crafts",
                         "crafting"
                     ],
        "filterable":  true
    },
    {
        "name":  "Šití",
        "key":  "motiv:siti",
        "group":  "motif_family",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:siti",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "šít",
                         "sewing"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hudební nástroje",
        "key":  "motiv:hudebni-nastroje",
        "group":  "motif_family",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudba",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hudební nástroj",
                         "nástroj",
                         "nástroje",
                         "musical instrument",
                         "musical instruments",
                         "instrument",
                         "instruments"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hudební média a technika",
        "key":  "motiv:hudebni-media-a-technika",
        "group":  "motif_family",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudba",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hudební technika",
                         "audio technika",
                         "music equipment",
                         "audio equipment",
                         "music media"
                     ],
        "filterable":  true
    },
    {
        "name":  "Hudební symboly",
        "key":  "motiv:hudebni-symboly",
        "group":  "motif_family",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-symboly",
        "fallback_key_1":  "motiv:hudba",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hudební symbol",
                         "hudební symboly",
                         "music symbol",
                         "music symbols"
                     ],
        "filterable":  true
    },
    {
        "name":  "Věda",
        "key":  "motiv:veda",
        "group":  "motif_family",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:veda",
        "fallback_key_1":  "motiv:veda-a-povolani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vědecký",
                         "vědkyně",
                         "vědec",
                         "science",
                         "scientist"
                     ],
        "filterable":  true
    },
    {
        "name":  "Biologie a genetika",
        "key":  "motiv:biologie-a-genetika",
        "group":  "motif_family",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:biologie-a-genetika",
        "fallback_key_1":  "motiv:veda-a-povolani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "biologie",
                         "genetika",
                         "biology",
                         "genetics"
                     ],
        "filterable":  true
    },
    {
        "name":  "Zdravotnictví",
        "key":  "motiv:zdravotnictvi",
        "group":  "motif_family",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:zdravotnictvi",
        "fallback_key_1":  "motiv:veda-a-povolani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "medicína",
                         "zdravotník",
                         "zdravotnice",
                         "healthcare",
                         "medicine",
                         "medical"
                     ],
        "filterable":  true
    },
    {
        "name":  "Lékařské nástroje",
        "key":  "motiv:lekarske-nastroje",
        "group":  "motif_family",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:lekarske-nastroje",
        "fallback_key_1":  "motiv:veda-a-povolani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "lékařský nástroj",
                         "zdravotnické nástroje",
                         "medical instrument",
                         "medical instruments",
                         "medical equipment"
                     ],
        "filterable":  true
    },
    {
        "name":  "Povolání",
        "key":  "motiv:povolani",
        "group":  "motif_family",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:veda-a-povolani",
        "fallback_key_2":  "",
        "synonyms":  [
                         "profese",
                         "práce",
                         "zaměstnání",
                         "profession",
                         "professions",
                         "occupation",
                         "career",
                         "job"
                     ],
        "filterable":  true
    },
    {
        "name":  "Astrologie",
        "key":  "motiv:astrologie",
        "group":  "motif_family",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:astrologie",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "astrologický",
                         "astrology",
                         "astrological"
                     ],
        "filterable":  true
    },
    {
        "name":  "Znamení zvěrokruhu",
        "key":  "motiv:znameni-zverokruhu",
        "group":  "motif_family",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "znamení",
                         "zvěrokruh",
                         "horoskop",
                         "zodiac",
                         "zodiac sign",
                         "zodiac signs",
                         "horoscope",
                         "star sign"
                     ],
        "filterable":  true
    },
    {
        "name":  "Náboženské symboly",
        "key":  "motiv:nabozenske-symboly",
        "group":  "motif_family",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:nabozenske-symboly",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "náboženský symbol",
                         "náboženské motivy",
                         "religious symbol",
                         "religious symbols",
                         "religious motifs"
                     ],
        "filterable":  true
    },
    {
        "name":  "Symboly štěstí",
        "key":  "motiv:symboly-stesti",
        "group":  "motif_family",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:symboly-stesti",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "symbol štěstí",
                         "pro štěstí",
                         "talisman",
                         "lucky symbol",
                         "lucky symbols",
                         "good luck",
                         "talisman"
                     ],
        "filterable":  true
    },
    {
        "name":  "Geometrické symboly",
        "key":  "motiv:geometricke-symboly",
        "group":  "motif_family",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "geometrický symbol",
                         "geometrické tvary",
                         "geometric symbol",
                         "geometric symbols",
                         "geometric shapes"
                     ],
        "filterable":  true
    },
    {
        "name":  "Královské motivy",
        "key":  "motiv:kralovske-motivy",
        "group":  "motif_family",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:kralovske-motivy",
        "fallback_key_1":  "motiv:fantazie",
        "fallback_key_2":  "",
        "synonyms":  [
                         "královský",
                         "královská",
                         "královské",
                         "royal",
                         "royalty"
                     ],
        "filterable":  true
    },
    {
        "name":  "Pohádkové motivy",
        "key":  "motiv:pohadkove-motivy",
        "group":  "motif_family",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:pohadkove-motivy",
        "fallback_key_1":  "motiv:fantazie",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pohádka",
                         "pohádkový",
                         "pohádková",
                         "fairytale",
                         "fairy tale",
                         "fairy tale motifs"
                     ],
        "filterable":  true
    },
    {
        "name":  "Mytologie",
        "key":  "motiv:mytologie",
        "group":  "motif_family",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:mytologie",
        "fallback_key_1":  "motiv:fantazie",
        "fallback_key_2":  "",
        "synonyms":  [
                         "mytologický",
                         "mytologické motivy",
                         "mythology",
                         "mythological",
                         "mythical"
                     ],
        "filterable":  true
    },
    {
        "name":  "Písmena a iniciály",
        "key":  "motiv:pismena-a-inicialy",
        "group":  "motif_family",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-vzkazy",
        "fallback_key_2":  "",
        "synonyms":  [
                         "písmeno",
                         "písmena",
                         "iniciála",
                         "iniciály",
                         "letter",
                         "letters",
                         "initial",
                         "initials"
                     ],
        "filterable":  true
    },
    {
        "name":  "Slova a nápisy",
        "key":  "motiv:slova-a-napisy",
        "group":  "motif_family",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:pismena-a-vzkazy",
        "fallback_key_2":  "",
        "synonyms":  [
                         "slovo",
                         "slova",
                         "nápis",
                         "text",
                         "word",
                         "words",
                         "inscription",
                         "text"
                     ],
        "filterable":  true
    },
    {
        "name":  "Dopisy a vzkazy",
        "key":  "motiv:dopisy-a-vzkazy",
        "group":  "motif_family",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:dopisy-a-vzkazy",
        "fallback_key_1":  "motiv:pismena-a-vzkazy",
        "fallback_key_2":  "",
        "synonyms":  [
                         "dopis",
                         "vzkaz",
                         "zpráva",
                         "letter",
                         "message",
                         "messages",
                         "note"
                     ],
        "filterable":  true
    },
    {
        "name":  "Každodenní předměty",
        "key":  "motiv:kazdodenni-predmety",
        "group":  "motif_family",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:predmety-a-technika",
        "fallback_key_2":  "",
        "synonyms":  [
                         "běžné předměty",
                         "věci",
                         "everyday object",
                         "everyday objects",
                         "common objects"
                     ],
        "filterable":  true
    },
    {
        "name":  "Čas a hodiny",
        "key":  "motiv:cas-a-hodiny",
        "group":  "motif_family",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:cas-a-hodiny",
        "fallback_key_1":  "motiv:predmety-a-technika",
        "fallback_key_2":  "",
        "synonyms":  [
                         "čas",
                         "hodiny",
                         "hodinky",
                         "time",
                         "clock",
                         "clocks",
                         "watch",
                         "watches"
                     ],
        "filterable":  true
    },
    {
        "name":  "Klíče a zámky",
        "key":  "motiv:klice-a-zamky",
        "group":  "motif_family",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:klice-a-zamky",
        "fallback_key_1":  "motiv:predmety-a-technika",
        "fallback_key_2":  "",
        "synonyms":  [
                         "klíč",
                         "klíče",
                         "zámek",
                         "zámky",
                         "key",
                         "keys",
                         "lock",
                         "locks"
                     ],
        "filterable":  true
    },
    {
        "name":  "Nástroje",
        "key":  "motiv:nastroje",
        "group":  "motif_family",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:nastroje",
        "fallback_key_1":  "motiv:predmety-a-technika",
        "fallback_key_2":  "",
        "synonyms":  [
                         "nářadí",
                         "pracovní nástroje",
                         "tool",
                         "tools",
                         "equipment"
                     ],
        "filterable":  true
    },
    {
        "name":  "Zbraně",
        "key":  "motiv:zbrane",
        "group":  "motif_family",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:zbrane",
        "fallback_key_1":  "motiv:predmety-a-technika",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zbraň",
                         "weapon",
                         "weapons"
                     ],
        "filterable":  true
    },
    {
        "name":  "Pes",
        "key":  "motiv:pes",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:mazlicci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "pejsek",
                         "pejsci",
                         "štěně",
                         "štěňátko",
                         "dog",
                         "dogs",
                         "puppy",
                         "puppies"
                     ],
        "filterable":  false
    },
    {
        "name":  "Balónkový pes",
        "key":  "motiv:balonkovy-pes",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:mazlicci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "pes z balónku",
                         "balónkové zvíře",
                         "balloon dog",
                         "balloon animal"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jezevčík",
        "key":  "motiv:jezevcik",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:mazlicci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "jezevčík pes",
                         "dachshund",
                         "sausage dog",
                         "wiener dog"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kočka",
        "key":  "motiv:kocka",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:mazlicci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "kočička",
                         "kotě",
                         "kočky",
                         "cat",
                         "cats",
                         "kitten",
                         "kittens"
                     ],
        "filterable":  false
    },
    {
        "name":  "Medvěd",
        "key":  "motiv:medved",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "medvídek",
                         "medvědi",
                         "bear",
                         "bears"
                     ],
        "filterable":  false
    },
    {
        "name":  "Velbloud",
        "key":  "motiv:velbloud",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "velbloudi",
                         "camel",
                         "camels"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kachna",
        "key":  "motiv:kachna",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "kačena",
                         "kačenka",
                         "duck",
                         "ducks"
                     ],
        "filterable":  false
    },
    {
        "name":  "Žába",
        "key":  "motiv:zaba",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "žabka",
                         "frog",
                         "frogs"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pták",
        "key":  "motiv:ptak",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "ptáček",
                         "ptáci",
                         "bird",
                         "birds"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kolibřík",
        "key":  "motiv:kolibrik",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "kolibříci",
                         "hummingbird",
                         "hummingbirds"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ryba",
        "key":  "motiv:ryba",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "rybička",
                         "ryby",
                         "fish",
                         "fishes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Had",
        "key":  "motiv:had",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "hadi",
                         "snake",
                         "snakes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Beruška",
        "key":  "motiv:beruska",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:hmyz",
        "fallback_key_1":  "motiv:hmyz",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "slunéčko sedmitečné",
                         "ladybug",
                         "ladybird"
                     ],
        "filterable":  false
    },
    {
        "name":  "Motýl",
        "key":  "motiv:motyl",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:hmyz",
        "fallback_key_1":  "motiv:hmyz",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "motýlek",
                         "motýli",
                         "butterfly",
                         "butterflies"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tlapka",
        "key":  "motiv:tlapka",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:zvireci-symboly",
        "fallback_key_1":  "motiv:zvireci-symboly",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "tlapa",
                         "otisk tlapky",
                         "psí tlapka",
                         "kočičí tlapka",
                         "paw",
                         "paw print",
                         "pet paw"
                     ],
        "filterable":  false
    },
    {
        "name":  "Psí miska",
        "key":  "motiv:psi-miska",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:potreby-pro-mazlicky",
        "fallback_key_1":  "motiv:potreby-pro-mazlicky",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "miska pro psa",
                         "miska pro mazlíčka",
                         "dog bowl",
                         "pet bowl"
                     ],
        "filterable":  false
    },
    {
        "name":  "Králík",
        "key":  "motiv:kralik",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:mazlicci",
        "fallback_key_1":  "motiv:mazlicci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "králíček",
                         "zajíček",
                         "rabbit",
                         "bunny"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kůň",
        "key":  "motiv:kun",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "koník",
                         "koně",
                         "horse",
                         "horses",
                         "pony"
                     ],
        "filterable":  false
    },
    {
        "name":  "Prase",
        "key":  "motiv:prase",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "prasátko",
                         "prasečí",
                         "pig",
                         "piglet"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kráva",
        "key":  "motiv:krava",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kravička",
                         "cow",
                         "cows"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ovce",
        "key":  "motiv:ovce",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "ovečka",
                         "sheep",
                         "lamb"
                     ],
        "filterable":  false
    },
    {
        "name":  "Koza",
        "key":  "motiv:koza",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kozička",
                         "goat",
                         "goats"
                     ],
        "filterable":  false
    },
    {
        "name":  "Slepice",
        "key":  "motiv:slepice",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "kuře",
                         "slepička",
                         "chicken",
                         "hen"
                     ],
        "filterable":  false
    },
    {
        "name":  "Myš",
        "key":  "motiv:mys",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "myška",
                         "mouse",
                         "mice"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ježek",
        "key":  "motiv:jezek",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "ježeček",
                         "hedgehog",
                         "hedgehogs"
                     ],
        "filterable":  false
    },
    {
        "name":  "Veverka",
        "key":  "motiv:veverka",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "veverky",
                         "squirrel",
                         "squirrels"
                     ],
        "filterable":  false
    },
    {
        "name":  "Liška",
        "key":  "motiv:liska",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "lištička",
                         "fox",
                         "foxes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vlk",
        "key":  "motiv:vlk",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "vlci",
                         "wolf",
                         "wolves"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jelen",
        "key":  "motiv:jelen",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "jelení",
                         "deer",
                         "stag"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lev",
        "key":  "motiv:lev",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "lví",
                         "lion",
                         "lions"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tygr",
        "key":  "motiv:tygr",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "tygří",
                         "tiger",
                         "tigers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Leopard",
        "key":  "motiv:leopard",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "leopardí",
                         "leopard",
                         "leopards"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zebra",
        "key":  "motiv:zebra",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "zebry",
                         "zebra",
                         "zebras"
                     ],
        "filterable":  false
    },
    {
        "name":  "Žirafa",
        "key":  "motiv:zirafa",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "žirafy",
                         "giraffe",
                         "giraffes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Slon",
        "key":  "motiv:slon",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "slůně",
                         "sloník",
                         "elephant",
                         "elephants"
                     ],
        "filterable":  false
    },
    {
        "name":  "Opice",
        "key":  "motiv:opice",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "opička",
                         "monkey",
                         "monkeys"
                     ],
        "filterable":  false
    },
    {
        "name":  "Panda",
        "key":  "motiv:panda",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "pandička",
                         "panda",
                         "pandas"
                     ],
        "filterable":  false
    },
    {
        "name":  "Koala",
        "key":  "motiv:koala",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_1":  "motiv:divoka-a-exoticka-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "koala bear",
                         "koala",
                         "koalas"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sova",
        "key":  "motiv:sova",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "sovička",
                         "owl",
                         "owls"
                     ],
        "filterable":  false
    },
    {
        "name":  "Papoušek",
        "key":  "motiv:papousek",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "papoušci",
                         "parrot",
                         "parrots"
                     ],
        "filterable":  false
    },
    {
        "name":  "Plameňák",
        "key":  "motiv:plamenak",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "flamingo",
                         "flamingos"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tučňák",
        "key":  "motiv:tucnak",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "tučňáci",
                         "penguin",
                         "penguins"
                     ],
        "filterable":  false
    },
    {
        "name":  "Labuť",
        "key":  "motiv:labut",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "labutě",
                         "swan",
                         "swans"
                     ],
        "filterable":  false
    },
    {
        "name":  "Orel",
        "key":  "motiv:orel",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:ptaci",
        "fallback_key_1":  "motiv:ptaci",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "orli",
                         "eagle",
                         "eagles"
                     ],
        "filterable":  false
    },
    {
        "name":  "Delfín",
        "key":  "motiv:delfin",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "delfínek",
                         "dolphin",
                         "dolphins"
                     ],
        "filterable":  false
    },
    {
        "name":  "Velryba",
        "key":  "motiv:velryba",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "whale",
                         "whales"
                     ],
        "filterable":  false
    },
    {
        "name":  "Žralok",
        "key":  "motiv:zralok",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "shark",
                         "sharks"
                     ],
        "filterable":  false
    },
    {
        "name":  "Chobotnice",
        "key":  "motiv:chobotnice",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "octopus",
                         "octopuses"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mořský koník",
        "key":  "motiv:morsky-konik",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "seahorse",
                         "sea horse"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mořská hvězdice",
        "key":  "motiv:morska-hvezdice",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "hvězdice",
                         "starfish",
                         "sea star"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mušle",
        "key":  "motiv:musle",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:vodni-zvirata",
        "fallback_key_1":  "motiv:vodni-zvirata",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "lastura",
                         "mušlička",
                         "shell",
                         "seashell",
                         "sea shell"
                     ],
        "filterable":  false
    },
    {
        "name":  "Želva",
        "key":  "motiv:zelva",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "želvička",
                         "turtle",
                         "tortoise"
                     ],
        "filterable":  false
    },
    {
        "name":  "Krokodýl",
        "key":  "motiv:krokodyl",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "krokodýli",
                         "crocodile",
                         "alligator"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ještěrka",
        "key":  "motiv:jesterka",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_1":  "motiv:plazi-a-obojzivelnici",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "ještěr",
                         "lizard",
                         "lizards"
                     ],
        "filterable":  false
    },
    {
        "name":  "Včela",
        "key":  "motiv:vcela",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:hmyz",
        "fallback_key_1":  "motiv:hmyz",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "včelka",
                         "včely",
                         "bee",
                         "bees"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vážka",
        "key":  "motiv:vazka",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:hmyz",
        "fallback_key_1":  "motiv:hmyz",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "dragonfly",
                         "dragonflies"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pavouk",
        "key":  "motiv:pavouk",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "",
        "fallback_key_1":  "motiv:zvirata",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pavouček",
                         "spider",
                         "spiders"
                     ],
        "filterable":  false
    },
    {
        "name":  "Psí kost",
        "key":  "motiv:psi-kost",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:potreby-pro-mazlicky",
        "fallback_key_1":  "motiv:potreby-pro-mazlicky",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "kost pro psa",
                         "psí kostička",
                         "dog bone",
                         "pet bone"
                     ],
        "filterable":  false
    },
    {
        "name":  "Obojek",
        "key":  "motiv:obojek",
        "group":  "main_motif",
        "overall_key":  "motiv:zvirata",
        "family_key":  "motiv:potreby-pro-mazlicky",
        "fallback_key_1":  "motiv:potreby-pro-mazlicky",
        "fallback_key_2":  "motiv:zvirata",
        "synonyms":  [
                         "psí obojek",
                         "kočičí obojek",
                         "obojek pro mazlíčka",
                         "pet collar",
                         "dog collar",
                         "cat collar"
                     ],
        "filterable":  false
    },
    {
        "name":  "Čokoláda",
        "key":  "motiv:cokolada",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:sladkosti",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "čoko",
                         "chocolate"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jahoda",
        "key":  "motiv:jahoda",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "jahody",
                         "strawberry",
                         "strawberries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Banán",
        "key":  "motiv:banan",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "banány",
                         "banana",
                         "bananas"
                     ],
        "filterable":  false
    },
    {
        "name":  "Avokádo",
        "key":  "motiv:avokado",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "avocado",
                         "avocados"
                     ],
        "filterable":  false
    },
    {
        "name":  "Chilli paprička",
        "key":  "motiv:chilli",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "chilli",
                         "chili",
                         "chilli pepper",
                         "chili pepper",
                         "hot pepper"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pizza",
        "key":  "motiv:pizza",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pizza slice",
                         "slice of pizza"
                     ],
        "filterable":  false
    },
    {
        "name":  "Donut",
        "key":  "motiv:donut",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:dezerty",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "kobliha",
                         "doughnut",
                         "donuts",
                         "doughnuts"
                     ],
        "filterable":  false
    },
    {
        "name":  "Dort",
        "key":  "motiv:dort",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:dezerty",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "dortík",
                         "narozeninový dort",
                         "cake",
                         "birthday cake"
                     ],
        "filterable":  false
    },
    {
        "name":  "Cupcake",
        "key":  "motiv:cupcake",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:dezerty",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "muffin",
                         "košíček",
                         "cupcakes",
                         "muffin"
                     ],
        "filterable":  false
    },
    {
        "name":  "Preclík",
        "key":  "motiv:preclik",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pretzel",
                         "pretzels"
                     ],
        "filterable":  false
    },
    {
        "name":  "Koktejl",
        "key":  "motiv:koktejl",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "drink",
                         "cocktail",
                         "cocktails"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sklenka vína",
        "key":  "motiv:sklenka-vina",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "víno",
                         "sklenice vína",
                         "wine glass",
                         "glass of wine"
                     ],
        "filterable":  false
    },
    {
        "name":  "Káva",
        "key":  "motiv:kava",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:kava-a-caj",
        "fallback_key_1":  "motiv:kava-a-caj",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "kafčo",
                         "coffee"
                     ],
        "filterable":  false
    },
    {
        "name":  "Konvička",
        "key":  "motiv:konvicka",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:kava-a-caj",
        "fallback_key_1":  "motiv:kava-a-caj",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "konvička",
                         "moka konvička",
                         "moka kávovar",
                         "moka pot",
                         "coffee maker",
                         "stovetop coffee maker",
                         "teapot",
                         "tea pot"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pivo",
        "key":  "motiv:pivo",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "beer"
                     ],
        "filterable":  false
    },
    {
        "name":  "Půllitr",
        "key":  "motiv:pullitr",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pivní sklenice",
                         "krýgl",
                         "beer mug",
                         "beer glass"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jablko",
        "key":  "motiv:jablko",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "jablka",
                         "apple",
                         "apples"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hruška",
        "key":  "motiv:hruska",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "hrušky",
                         "pear",
                         "pears"
                     ],
        "filterable":  false
    },
    {
        "name":  "Třešně",
        "key":  "motiv:tresne",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "třešeň",
                         "třešnička",
                         "cherry",
                         "cherries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hrozny",
        "key":  "motiv:hrozny",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "vinné hrozny",
                         "hroznové víno",
                         "grapes",
                         "grape"
                     ],
        "filterable":  false
    },
    {
        "name":  "Citron",
        "key":  "motiv:citron",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "citróny",
                         "lemon",
                         "lemons"
                     ],
        "filterable":  false
    },
    {
        "name":  "Limetka",
        "key":  "motiv:limetka",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "lime",
                         "limes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pomeranč",
        "key":  "motiv:pomeranc",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pomeranče",
                         "orange",
                         "oranges"
                     ],
        "filterable":  false
    },
    {
        "name":  "Meloun",
        "key":  "motiv:meloun",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "vodní meloun",
                         "watermelon",
                         "watermelons"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ananas",
        "key":  "motiv:ananas",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pineapple",
                         "pineapples"
                     ],
        "filterable":  false
    },
    {
        "name":  "Broskev",
        "key":  "motiv:broskev",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "broskve",
                         "peach",
                         "peaches"
                     ],
        "filterable":  false
    },
    {
        "name":  "Malina",
        "key":  "motiv:malina",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "maliny",
                         "raspberry",
                         "raspberries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Borůvka",
        "key":  "motiv:boruvka",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "borůvky",
                         "blueberry",
                         "blueberries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Houba",
        "key":  "motiv:houba",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "houbička",
                         "houby",
                         "mushroom",
                         "mushrooms"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mrkev",
        "key":  "motiv:mrkev",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "mrkvička",
                         "carrot",
                         "carrots"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kukuřice",
        "key":  "motiv:kukurice",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "klas kukuřice",
                         "corn",
                         "sweetcorn"
                     ],
        "filterable":  false
    },
    {
        "name":  "Rajče",
        "key":  "motiv:rajce",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:ovoce-a-zelenina",
        "fallback_key_1":  "motiv:ovoce-a-zelenina",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "rajčata",
                         "tomato",
                         "tomatoes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Burger",
        "key":  "motiv:burger",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "hamburger",
                         "cheeseburger",
                         "burgers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hranolky",
        "key":  "motiv:hranolky",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "hranolky frites",
                         "fries",
                         "french fries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hot dog",
        "key":  "motiv:hot-dog",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "párek v rohlíku",
                         "hotdog",
                         "hot dogs"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sushi",
        "key":  "motiv:sushi",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "sushi roll",
                         "sushi rolls"
                     ],
        "filterable":  false
    },
    {
        "name":  "Taco",
        "key":  "motiv:taco",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "tacos"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sendvič",
        "key":  "motiv:sendvic",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "sandwich",
                         "sandwiches"
                     ],
        "filterable":  false
    },
    {
        "name":  "Těstoviny",
        "key":  "motiv:testoviny",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "pasta",
                         "noodles"
                     ],
        "filterable":  false
    },
    {
        "name":  "Croissant",
        "key":  "motiv:croissant",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "",
        "fallback_key_1":  "motiv:gastro",
        "fallback_key_2":  "",
        "synonyms":  [
                         "croissanty",
                         "croissants"
                     ],
        "filterable":  false
    },
    {
        "name":  "Chléb",
        "key":  "motiv:chleb",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:slana-jidla",
        "fallback_key_1":  "motiv:slana-jidla",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "chleba",
                         "pečivo",
                         "bread"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zmrzlina",
        "key":  "motiv:zmrzlina",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:dezerty",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "nanuk",
                         "kopeček zmrzliny",
                         "ice cream",
                         "icecream"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sušenka",
        "key":  "motiv:susenka",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:sladkosti",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "sušenky",
                         "cookie",
                         "cookies",
                         "biscuit",
                         "biscuits"
                     ],
        "filterable":  false
    },
    {
        "name":  "Makronka",
        "key":  "motiv:makronka",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:dezerty",
        "fallback_key_1":  "motiv:dezerty",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "makronky",
                         "macaron",
                         "macarons"
                     ],
        "filterable":  false
    },
    {
        "name":  "Bonbon",
        "key":  "motiv:bonbon",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:sladkosti",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "bonbón",
                         "bonbony",
                         "candy",
                         "sweets"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lízátko",
        "key":  "motiv:lizatko",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:sladkosti",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "lízátka",
                         "lollipop",
                         "lollipops"
                     ],
        "filterable":  false
    },
    {
        "name":  "Med",
        "key":  "motiv:med",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:sladkosti",
        "fallback_key_1":  "motiv:sladkosti",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "honey"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šálek čaje",
        "key":  "motiv:salek-caje",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:kava-a-caj",
        "fallback_key_1":  "motiv:kava-a-caj",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "čaj",
                         "hrnek čaje",
                         "cup of tea",
                         "tea cup",
                         "teacup"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šálek kávy",
        "key":  "motiv:salek-kavy",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:kava-a-caj",
        "fallback_key_1":  "motiv:kava-a-caj",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "kafe",
                         "hrnek kávy",
                         "cup of coffee",
                         "coffee cup"
                     ],
        "filterable":  false
    },
    {
        "name":  "Láhev vína",
        "key":  "motiv:lahev-vina",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "víno",
                         "vinná láhev",
                         "bottle of wine",
                         "wine bottle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sekt",
        "key":  "motiv:sekt",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "šumivé víno",
                         "prosecco",
                         "champagne",
                         "sparkling wine"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sklenka sektu",
        "key":  "motiv:sklenka-sektu",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:alkoholicke-napoje",
        "fallback_key_1":  "motiv:alkoholicke-napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "sklenka prosecca",
                         "sklenka šampaňského",
                         "champagne glass",
                         "prosecco glass",
                         "sparkling wine glass"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mléčný koktejl",
        "key":  "motiv:milkshake",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:napoje",
        "fallback_key_1":  "motiv:napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "mléčný shake",
                         "milkshake",
                         "milk shake"
                     ],
        "filterable":  false
    },
    {
        "name":  "Bubble tea",
        "key":  "motiv:bubble-tea",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:napoje",
        "fallback_key_1":  "motiv:napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "boba",
                         "boba tea",
                         "bubbletea",
                         "pearl milk tea"
                     ],
        "filterable":  false
    },
    {
        "name":  "Limonáda",
        "key":  "motiv:limonada",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:napoje",
        "fallback_key_1":  "motiv:napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "limo",
                         "lemonade",
                         "soft drink"
                     ],
        "filterable":  false
    },
    {
        "name":  "Džus",
        "key":  "motiv:dzus",
        "group":  "main_motif",
        "overall_key":  "motiv:gastro",
        "family_key":  "motiv:napoje",
        "fallback_key_1":  "motiv:napoje",
        "fallback_key_2":  "motiv:gastro",
        "synonyms":  [
                         "ovocný džus",
                         "juice",
                         "fruit juice"
                     ],
        "filterable":  false
    },
    {
        "name":  "Slunce",
        "key":  "motiv:slunce",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:nebeska-telesa",
        "fallback_key_1":  "motiv:nebeska-telesa",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "sluníčko",
                         "sluneční motiv",
                         "sun",
                         "sunshine",
                         "solar"
                     ],
        "filterable":  false
    },
    {
        "name":  "Měsíc",
        "key":  "motiv:mesic",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:nebeska-telesa",
        "fallback_key_1":  "motiv:nebeska-telesa",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "luna",
                         "moon",
                         "crescent moon"
                     ],
        "filterable":  false
    },
    {
        "name":  "Slunce a měsíc",
        "key":  "motiv:slunce-a-mesic",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:nebeska-telesa",
        "fallback_key_1":  "motiv:nebeska-telesa",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "slunce měsíc",
                         "sun and moon",
                         "sun moon",
                         "celestial pair"
                     ],
        "filterable":  false
    },
    {
        "name":  "Květina",
        "key":  "motiv:kvetina",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "květ",
                         "kytička",
                         "kytka",
                         "flower",
                         "flowers",
                         "floral"
                     ],
        "filterable":  false
    },
    {
        "name":  "List",
        "key":  "motiv:list",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:listy-a-vetvicky",
        "fallback_key_1":  "motiv:listy-a-vetvicky",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "lístek",
                         "leaf",
                         "leaves"
                     ],
        "filterable":  false
    },
    {
        "name":  "Větvička",
        "key":  "motiv:vetvicka",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:listy-a-vetvicky",
        "fallback_key_1":  "motiv:listy-a-vetvicky",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "větev",
                         "branch",
                         "twig"
                     ],
        "filterable":  false
    },
    {
        "name":  "Duha",
        "key":  "motiv:duha",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "rainbow",
                         "rainbows"
                     ],
        "filterable":  false
    },
    {
        "name":  "Růže",
        "key":  "motiv:ruze",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "růžička",
                         "rose",
                         "roses"
                     ],
        "filterable":  false
    },
    {
        "name":  "Slunečnice",
        "key":  "motiv:slunecnice",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "sunflower",
                         "sunflowers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sedmikráska",
        "key":  "motiv:sedmikraska",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "kopretina",
                         "daisy",
                         "daisies"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tulipán",
        "key":  "motiv:tulipan",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "tulip",
                         "tulips"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sakura",
        "key":  "motiv:sakura",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "třešňový květ",
                         "květ sakury",
                         "cherry blossom",
                         "cherry blossoms"
                     ],
        "filterable":  false
    },
    {
        "name":  "Levandule",
        "key":  "motiv:levandule",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "lavender"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lotos",
        "key":  "motiv:lotus",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "lotosový květ",
                         "lotus",
                         "lotus flower"
                     ],
        "filterable":  false
    },
    {
        "name":  "Strom",
        "key":  "motiv:strom",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "stromek",
                         "tree",
                         "trees"
                     ],
        "filterable":  false
    },
    {
        "name":  "Palma",
        "key":  "motiv:palma",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "palmový strom",
                         "palm",
                         "palm tree"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kaktus",
        "key":  "motiv:kaktus",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:kvetiny-a-rostliny",
        "fallback_key_1":  "motiv:kvetiny-a-rostliny",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "cactus",
                         "cacti"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hora",
        "key":  "motiv:hora",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "",
        "fallback_key_1":  "motiv:priroda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hory",
                         "pohoří",
                         "mountain",
                         "mountains"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vlna",
        "key":  "motiv:vlna",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "mořská vlna",
                         "vlny",
                         "wave",
                         "waves",
                         "ocean wave"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mrak",
        "key":  "motiv:mrak",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "mráček",
                         "oblak",
                         "cloud",
                         "clouds"
                     ],
        "filterable":  false
    },
    {
        "name":  "Deštník",
        "key":  "motiv:destnik",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "paraple",
                         "umbrella"
                     ],
        "filterable":  false
    },
    {
        "name":  "Blesk",
        "key":  "motiv:blesk",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "lightning",
                         "lightning bolt",
                         "thunderbolt"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sněhová vločka",
        "key":  "motiv:vlocka",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "vločka",
                         "sníh",
                         "snowflake",
                         "snow"
                     ],
        "filterable":  false
    },
    {
        "name":  "Oheň",
        "key":  "motiv:ohen",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_1":  "motiv:pocasi-a-prirodni-jevy",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "plamen",
                         "plameny",
                         "fire",
                         "flame",
                         "flames"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hvězda",
        "key":  "motiv:hvezda",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:nebeska-telesa",
        "fallback_key_1":  "motiv:nebeska-telesa",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "hvězdička",
                         "star",
                         "stars"
                     ],
        "filterable":  false
    },
    {
        "name":  "Planeta",
        "key":  "motiv:planeta",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:vesmir",
        "fallback_key_1":  "motiv:vesmir",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "planety",
                         "planet",
                         "planets"
                     ],
        "filterable":  false
    },
    {
        "name":  "Saturn",
        "key":  "motiv:saturn",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:vesmir",
        "fallback_key_1":  "motiv:vesmir",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "planeta Saturn",
                         "Saturn planet"
                     ],
        "filterable":  false
    },
    {
        "name":  "Raketa",
        "key":  "motiv:raketa",
        "group":  "main_motif",
        "overall_key":  "motiv:priroda",
        "family_key":  "motiv:vesmir",
        "fallback_key_1":  "motiv:vesmir",
        "fallback_key_2":  "motiv:priroda",
        "synonyms":  [
                         "vesmírná raketa",
                         "rocket",
                         "space rocket",
                         "spaceship"
                     ],
        "filterable":  false
    },
    {
        "name":  "Orloj",
        "key":  "motiv:orloj",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "pražský orloj",
                         "staroměstský orloj",
                         "Prague astronomical clock",
                         "astronomical clock"
                     ],
        "filterable":  false
    },
    {
        "name":  "Praha",
        "key":  "motiv:praha",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "Prague",
                         "hlavní město Česka",
                         "Czech capital"
                     ],
        "filterable":  false
    },
    {
        "name":  "Horkovzdušný balón",
        "key":  "motiv:horkovzdusny-balon",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "balón",
                         "vzdušný balón",
                         "hot air balloon",
                         "air balloon"
                     ],
        "filterable":  false
    },
    {
        "name":  "Letadlo",
        "key":  "motiv:letadlo",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "letoun",
                         "airplane",
                         "aeroplane",
                         "plane",
                         "aircraft"
                     ],
        "filterable":  false
    },
    {
        "name":  "Faraon",
        "key":  "motiv:faraon",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:historie",
        "fallback_key_1":  "motiv:historie",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "egyptský faraon",
                         "Egypt",
                         "Egyptian",
                         "pharaoh",
                         "Egyptian pharaoh"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kufr",
        "key":  "motiv:kufr",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "cestovní kufr",
                         "zavazadlo",
                         "suitcase",
                         "luggage"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pas",
        "key":  "motiv:pas",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "cestovní pas",
                         "passport",
                         "travel passport"
                     ],
        "filterable":  false
    },
    {
        "name":  "Glóbus",
        "key":  "motiv:globus",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "zeměkoule",
                         "globe",
                         "world globe"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mapa",
        "key":  "motiv:mapa",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "mapa světa",
                         "cestovní mapa",
                         "map",
                         "world map",
                         "travel map"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kompas",
        "key":  "motiv:kompas",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "compass",
                         "travel compass"
                     ],
        "filterable":  false
    },
    {
        "name":  "Auto",
        "key":  "motiv:auto",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "automobil",
                         "vůz",
                         "car",
                         "automobile"
                     ],
        "filterable":  false
    },
    {
        "name":  "Autobus",
        "key":  "motiv:autobus",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "bus",
                         "coach"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vlak",
        "key":  "motiv:vlak",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "železnice",
                         "train",
                         "railway"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jízdní kolo",
        "key":  "motiv:kolo",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "bicykl",
                         "kolo",
                         "bicycle",
                         "bike",
                         "cycling"
                     ],
        "filterable":  false
    },
    {
        "name":  "Motorka",
        "key":  "motiv:motorka",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "motocykl",
                         "motorcycle",
                         "motorbike"
                     ],
        "filterable":  false
    },
    {
        "name":  "Loď",
        "key":  "motiv:lod",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "člun",
                         "loďka",
                         "boat",
                         "ship"
                     ],
        "filterable":  false
    },
    {
        "name":  "Plachetnice",
        "key":  "motiv:plachetnice",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "plachetní loď",
                         "sailboat",
                         "sailing boat",
                         "yacht"
                     ],
        "filterable":  false
    },
    {
        "name":  "Karavan",
        "key":  "motiv:karavan",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:doprava-a-cestovani",
        "fallback_key_1":  "motiv:doprava-a-cestovani",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "obytné auto",
                         "camper",
                         "campervan",
                         "camper van",
                         "caravan"
                     ],
        "filterable":  false
    },
    {
        "name":  "Stan",
        "key":  "motiv:stan",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:cestovni-vzpominky",
        "fallback_key_1":  "motiv:cestovni-vzpominky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "kempování",
                         "camping",
                         "tent"
                     ],
        "filterable":  false
    },
    {
        "name":  "Eiffelova věž",
        "key":  "motiv:eiffelova-vez",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "Eiffelovka",
                         "Paříž",
                         "Paris",
                         "Eiffel Tower"
                     ],
        "filterable":  false
    },
    {
        "name":  "Big Ben",
        "key":  "motiv:big-ben",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "Londýn",
                         "London",
                         "Big Ben London"
                     ],
        "filterable":  false
    },
    {
        "name":  "Koloseum",
        "key":  "motiv:koloseum",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "římské koloseum",
                         "Řím",
                         "Rome",
                         "Colosseum",
                         "Roman Colosseum"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pyramida",
        "key":  "motiv:pyramida",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:historie",
        "fallback_key_1":  "motiv:historie",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "pyramidy",
                         "egyptská pyramida",
                         "Egypt",
                         "pyramid",
                         "pyramids",
                         "Egyptian pyramid"
                     ],
        "filterable":  false
    },
    {
        "name":  "Karlův most",
        "key":  "motiv:karluv-most",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "Charles Bridge",
                         "pražský most",
                         "Prague bridge"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pražský hrad",
        "key":  "motiv:prazsky-hrad",
        "group":  "main_motif",
        "overall_key":  "motiv:cestovani",
        "family_key":  "motiv:mesta-a-pamatky",
        "fallback_key_1":  "motiv:mesta-a-pamatky",
        "fallback_key_2":  "motiv:cestovani",
        "synonyms":  [
                         "Prague Castle",
                         "hrad v Praze",
                         "Prague castle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kabelka",
        "key":  "motiv:kabelka",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:kabelky",
        "fallback_key_1":  "motiv:kabelky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "taška",
                         "handbag",
                         "purse",
                         "bag"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mašle",
        "key":  "motiv:masle",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "mašlička",
                         "bow",
                         "ribbon bow"
                     ],
        "filterable":  false
    },
    {
        "name":  "Teniska",
        "key":  "motiv:teniska",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:obuv",
        "fallback_key_1":  "motiv:obuv",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "tenisky",
                         "sneaker",
                         "sneakers",
                         "trainer",
                         "trainers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kolečková brusle",
        "key":  "motiv:koleckova-brusle",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:obuv",
        "fallback_key_1":  "motiv:obuv",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "kolečkové brusle",
                         "brusle",
                         "roller skate",
                         "roller skates",
                         "rollerskates"
                     ],
        "filterable":  false
    },
    {
        "name":  "Podpatek",
        "key":  "motiv:podpatek",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:obuv",
        "fallback_key_1":  "motiv:obuv",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "vysoký podpatek",
                         "lodička",
                         "high heel",
                         "high heels",
                         "heel",
                         "heels"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šaty",
        "key":  "motiv:saty",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "",
        "fallback_key_1":  "motiv:moda",
        "fallback_key_2":  "",
        "synonyms":  [
                         "šatičky",
                         "dress",
                         "dresses"
                     ],
        "filterable":  false
    },
    {
        "name":  "Brýle",
        "key":  "motiv:bryle",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "dioptrické brýle",
                         "glasses",
                         "eyeglasses",
                         "spectacles"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sluneční brýle",
        "key":  "motiv:slunecni-bryle",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "sluneční brýle",
                         "sunglasses",
                         "shades"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klobouk",
        "key":  "motiv:klobouk",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "klobouček",
                         "hat",
                         "hats"
                     ],
        "filterable":  false
    },
    {
        "name":  "Rtěnka",
        "key":  "motiv:rtenka",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "makeup",
                         "líčení",
                         "lipstick",
                         "make up",
                         "cosmetics"
                     ],
        "filterable":  false
    },
    {
        "name":  "Parfém",
        "key":  "motiv:parfem",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "voňavka",
                         "vůně",
                         "perfume",
                         "fragrance"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zrcadlo",
        "key":  "motiv:zrcadlo",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "zrcátko",
                         "mirror"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hřeben",
        "key":  "motiv:hreben",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "hřebínek",
                         "comb",
                         "hair comb"
                     ],
        "filterable":  false
    },
    {
        "name":  "Prsten",
        "key":  "motiv:prsten",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "prstýnek",
                         "ring",
                         "rings"
                     ],
        "filterable":  false
    },
    {
        "name":  "Diamant",
        "key":  "motiv:diamant",
        "group":  "main_motif",
        "overall_key":  "motiv:moda",
        "family_key":  "motiv:modni-doplnky",
        "fallback_key_1":  "motiv:modni-doplnky",
        "fallback_key_2":  "motiv:moda",
        "synonyms":  [
                         "briliant",
                         "diamond",
                         "diamonds",
                         "gemstone"
                     ],
        "filterable":  false
    },
    {
        "name":  "Herní ovladač",
        "key":  "motiv:herni-ovladac",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:videohry",
        "fallback_key_1":  "motiv:videohry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "ovladač",
                         "gamepad",
                         "controller",
                         "game controller",
                         "gaming controller"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hrací karta",
        "key":  "motiv:hraci-karta",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "karta",
                         "karty",
                         "playing card",
                         "playing cards",
                         "card game"
                     ],
        "filterable":  false
    },
    {
        "name":  "Srdcové eso",
        "key":  "motiv:srdcove-eso",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "eso srdcové",
                         "eso srdcí",
                         "ace of hearts",
                         "heart ace"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hrací kostka",
        "key":  "motiv:kostka",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "kostky",
                         "herní kostka",
                         "dice",
                         "die",
                         "gaming dice"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachová figurka",
        "key":  "motiv:sachova-figurka",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "šachy",
                         "šachová figura",
                         "chess",
                         "chess piece",
                         "chess pieces"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachový kůň",
        "key":  "motiv:sachovy-kun",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "kůň v šachu",
                         "jezdec",
                         "chess knight",
                         "knight"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachová dáma",
        "key":  "motiv:sachova-dama",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "dáma v šachu",
                         "královna",
                         "chess queen",
                         "queen"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachový král",
        "key":  "motiv:sachovy-kral",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "král v šachu",
                         "chess king",
                         "king"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachová věž",
        "key":  "motiv:sachova-vez",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "věž v šachu",
                         "chess rook",
                         "rook"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachový střelec",
        "key":  "motiv:sachovy-strelec",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "střelec v šachu",
                         "chess bishop",
                         "bishop"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šachový pěšec",
        "key":  "motiv:sachovy-pesec",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "pěšák",
                         "pěšec v šachu",
                         "chess pawn",
                         "pawn"
                     ],
        "filterable":  false
    },
    {
        "name":  "Domino",
        "key":  "motiv:domino",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "domino kostka",
                         "domino tile",
                         "dominoes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Dílek puzzle",
        "key":  "motiv:puzzle",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "puzzle",
                         "puzzlík",
                         "dílek skládačky",
                         "puzzle piece",
                         "jigsaw piece"
                     ],
        "filterable":  false
    },
    {
        "name":  "Joystick",
        "key":  "motiv:joystick",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:videohry",
        "fallback_key_1":  "motiv:videohry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "herní páka",
                         "joystick controller",
                         "gaming joystick"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kulečníková koule",
        "key":  "motiv:kulecnikova-koule",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "biliárová koule",
                         "billiard ball",
                         "pool ball",
                         "billiards",
                         "pool"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ruleta",
        "key":  "motiv:ruleta",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "ruletové kolo",
                         "roulette",
                         "roulette wheel"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pokerový žeton",
        "key":  "motiv:pokerovy-zeton",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "motiv:spolecenske-hry",
        "fallback_key_1":  "motiv:spolecenske-hry",
        "fallback_key_2":  "motiv:sport",
        "synonyms":  [
                         "poker",
                         "žeton",
                         "poker chip",
                         "casino chip"
                     ],
        "filterable":  false
    },
    {
        "name":  "Činka",
        "key":  "motiv:cinka",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "činky",
                         "posilování",
                         "fitness",
                         "dumbbell",
                         "weights",
                         "weightlifting"
                     ],
        "filterable":  false
    },
    {
        "name":  "Badmintonový košík",
        "key":  "motiv:badmintonovy-kosik",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "badminton",
                         "košíček",
                         "badmintonový míček",
                         "shuttlecock",
                         "badminton shuttle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tenisová raketa",
        "key":  "motiv:tenisova-raketa",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "tenis",
                         "raketa na tenis",
                         "tennis",
                         "tennis racket",
                         "tennis racquet"
                     ],
        "filterable":  false
    },
    {
        "name":  "Badmintonová raketa",
        "key":  "motiv:badmintonova-raketa",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "badminton",
                         "raketa na badminton",
                         "badminton racket",
                         "badminton racquet"
                     ],
        "filterable":  false
    },
    {
        "name":  "Fotbalový míč",
        "key":  "motiv:fotbalovy-mic",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "fotbal",
                         "kopaná",
                         "soccer",
                         "football",
                         "soccer ball",
                         "football ball"
                     ],
        "filterable":  false
    },
    {
        "name":  "Basketbalový míč",
        "key":  "motiv:basketbalovy-mic",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "basketbal",
                         "basketball",
                         "basketball ball"
                     ],
        "filterable":  false
    },
    {
        "name":  "Volejbalový míč",
        "key":  "motiv:volejbalovy-mic",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "volejbal",
                         "volleyball",
                         "volleyball ball"
                     ],
        "filterable":  false
    },
    {
        "name":  "Baseballový míč",
        "key":  "motiv:baseballovy-mic",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "baseball",
                         "baseball ball"
                     ],
        "filterable":  false
    },
    {
        "name":  "Golfový míček",
        "key":  "motiv:golfovy-mic",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "golf",
                         "golf ball"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hokejka",
        "key":  "motiv:hokejka",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hokej",
                         "hockey",
                         "hockey stick"
                     ],
        "filterable":  false
    },
    {
        "name":  "Boxerská rukavice",
        "key":  "motiv:boxerska-rukavice",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "box",
                         "boxování",
                         "boxing",
                         "boxing glove",
                         "boxing gloves"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lyže",
        "key":  "motiv:lyze",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "lyžování",
                         "ski",
                         "skis",
                         "skiing"
                     ],
        "filterable":  false
    },
    {
        "name":  "Snowboard",
        "key":  "motiv:snowboard",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "snowboarding",
                         "snowboarder"
                     ],
        "filterable":  false
    },
    {
        "name":  "Surf",
        "key":  "motiv:surf",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "surfování",
                         "surfboard",
                         "surfing",
                         "surfer"
                     ],
        "filterable":  false
    },
    {
        "name":  "Medaile",
        "key":  "motiv:medaile",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "medailová",
                         "medal",
                         "medals",
                         "award"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pohár",
        "key":  "motiv:pohar",
        "group":  "main_motif",
        "overall_key":  "motiv:sport",
        "family_key":  "",
        "fallback_key_1":  "motiv:sport",
        "fallback_key_2":  "",
        "synonyms":  [
                         "trofej",
                         "vítězný pohár",
                         "trophy",
                         "cup",
                         "winner cup"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kytara",
        "key":  "motiv:kytara",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "kytary",
                         "kytarista",
                         "kytaristka",
                         "guitar",
                         "guitars",
                         "guitarist"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kazeta",
        "key":  "motiv:kazeta",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudebni-media-a-technika",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "audiokazeta",
                         "magnetofonová kazeta",
                         "cassette",
                         "cassette tape",
                         "tape"
                     ],
        "filterable":  false
    },
    {
        "name":  "Piano",
        "key":  "motiv:piano",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "klavír",
                         "klavírista",
                         "klavíristka",
                         "piano",
                         "pianist"
                     ],
        "filterable":  false
    },
    {
        "name":  "Housle",
        "key":  "motiv:housle",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "houslista",
                         "houslistka",
                         "violin",
                         "violins",
                         "violinist"
                     ],
        "filterable":  false
    },
    {
        "name":  "Bicí",
        "key":  "motiv:bici",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "bubny",
                         "bubeník",
                         "bubenice",
                         "drums",
                         "drummer",
                         "drum kit"
                     ],
        "filterable":  false
    },
    {
        "name":  "Saxofon",
        "key":  "motiv:saxofon",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "saxík",
                         "saxofonista",
                         "saxofonistka",
                         "saxophone",
                         "sax",
                         "saxophonist"
                     ],
        "filterable":  false
    },
    {
        "name":  "Trubka",
        "key":  "motiv:trubka",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "trumpeta",
                         "trumpet",
                         "trumpeter"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ukulele",
        "key":  "motiv:ukulele",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "uke",
                         "ukulele player"
                     ],
        "filterable":  false
    },
    {
        "name":  "Harfa",
        "key":  "motiv:harfa",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "harfistka",
                         "harfista",
                         "harp",
                         "harpist"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mikrofon",
        "key":  "motiv:mikrofon",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-nastroje",
        "fallback_key_1":  "motiv:hudebni-nastroje",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "mikrák",
                         "zpěv",
                         "zpěvák",
                         "zpěvačka",
                         "microphone",
                         "mic",
                         "singer",
                         "singing"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sluchátka",
        "key":  "motiv:sluchatka",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudebni-media-a-technika",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "sluchátko",
                         "headphones",
                         "earphones",
                         "headset"
                     ],
        "filterable":  false
    },
    {
        "name":  "Reproduktor",
        "key":  "motiv:reproduktor",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudebni-media-a-technika",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "reprák",
                         "speaker",
                         "speakers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Gramofon",
        "key":  "motiv:gramofon",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudebni-media-a-technika",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "přehrávač desek",
                         "record player",
                         "turntable"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vinylová deska",
        "key":  "motiv:vinylova-deska",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-media-a-technika",
        "fallback_key_1":  "motiv:hudebni-media-a-technika",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "vinyl",
                         "gramodeska",
                         "deska",
                         "vinyl record",
                         "record",
                         "LP"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hudební nota",
        "key":  "motiv:hudebni-nota",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-symboly",
        "fallback_key_1":  "motiv:hudebni-symboly",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "nota",
                         "noty",
                         "music note",
                         "musical note",
                         "notes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Houslový klíč",
        "key":  "motiv:houslovy-klic",
        "group":  "main_motif",
        "overall_key":  "motiv:hudba",
        "family_key":  "motiv:hudebni-symboly",
        "fallback_key_1":  "motiv:hudebni-symboly",
        "fallback_key_2":  "motiv:hudba",
        "synonyms":  [
                         "hudební klíč",
                         "treble clef",
                         "G clef"
                     ],
        "filterable":  false
    },
    {
        "name":  "Fotoaparát",
        "key":  "motiv:fotoaparat",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:fotografie",
        "fallback_key_1":  "motiv:fotografie",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "foťák",
                         "focení",
                         "fotografie",
                         "camera",
                         "photography",
                         "photographer"
                     ],
        "filterable":  false
    },
    {
        "name":  "Nůžky",
        "key":  "motiv:nuzky",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "scissors",
                         "shears"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kniha",
        "key":  "motiv:kniha",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:cteni-a-psani",
        "fallback_key_1":  "motiv:cteni-a-psani",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "knížka",
                         "čtení",
                         "čtenář",
                         "čtenářka",
                         "book",
                         "books",
                         "reading",
                         "reader"
                     ],
        "filterable":  false
    },
    {
        "name":  "Štětec",
        "key":  "motiv:stetec",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "malování",
                         "malířský štětec",
                         "paintbrush",
                         "brush",
                         "painting"
                     ],
        "filterable":  false
    },
    {
        "name":  "Malířská paleta",
        "key":  "motiv:malirska-paleta",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "paleta",
                         "malování",
                         "palette",
                         "paint palette",
                         "artist palette"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tužka",
        "key":  "motiv:tuzka",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:cteni-a-psani",
        "fallback_key_1":  "motiv:cteni-a-psani",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "kreslení",
                         "psaní",
                         "pencil",
                         "drawing",
                         "writing"
                     ],
        "filterable":  false
    },
    {
        "name":  "Šicí stroj",
        "key":  "motiv:sici-stroj",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:siti",
        "fallback_key_1":  "motiv:siti",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "šití",
                         "švadlena",
                         "sewing machine",
                         "sewing"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klubko vlny",
        "key":  "motiv:klubko-vlny",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "vlna",
                         "příze",
                         "pletení",
                         "yarn",
                         "ball of yarn",
                         "knitting"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pletací jehlice",
        "key":  "motiv:pletaci-jehlice",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "jehlice",
                         "pletení",
                         "knitting needles",
                         "knitting"
                     ],
        "filterable":  false
    },
    {
        "name":  "Háček",
        "key":  "motiv:hacek",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "motiv:rucni-prace",
        "fallback_key_1":  "motiv:rucni-prace",
        "fallback_key_2":  "motiv:hobby",
        "synonyms":  [
                         "háčkování",
                         "crochet hook",
                         "crochet",
                         "crocheting"
                     ],
        "filterable":  false
    },
    {
        "name":  "Filmová klapka",
        "key":  "motiv:filmove-prkno",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "klapka",
                         "film",
                         "natáčení",
                         "clapperboard",
                         "movie",
                         "filmmaking"
                     ],
        "filterable":  false
    },
    {
        "name":  "Divadelní masky",
        "key":  "motiv:divadelni-masky",
        "group":  "main_motif",
        "overall_key":  "motiv:hobby",
        "family_key":  "",
        "fallback_key_1":  "motiv:hobby",
        "fallback_key_2":  "",
        "synonyms":  [
                         "divadlo",
                         "komedie a tragédie",
                         "theatre masks",
                         "theater masks",
                         "theatre",
                         "drama masks"
                     ],
        "filterable":  false
    },
    {
        "name":  "DNA",
        "key":  "motiv:dna",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:biologie-a-genetika",
        "fallback_key_1":  "motiv:biologie-a-genetika",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "genetika",
                         "geny",
                         "dna strand",
                         "genetics",
                         "genes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Stříkačka",
        "key":  "motiv:strikacka",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:lekarske-nastroje",
        "fallback_key_1":  "motiv:lekarske-nastroje",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "injekce",
                         "syringe",
                         "injection",
                         "needle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Stetoskop",
        "key":  "motiv:stetoskop",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:lekarske-nastroje",
        "fallback_key_1":  "motiv:lekarske-nastroje",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "doktor",
                         "lékař",
                         "zdravotník",
                         "stethoscope",
                         "doctor",
                         "medical"
                     ],
        "filterable":  false
    },
    {
        "name":  "Atom",
        "key":  "motiv:atom",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:veda",
        "fallback_key_1":  "motiv:veda",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "fyzika",
                         "věda",
                         "atom symbol",
                         "physics",
                         "science"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mikroskop",
        "key":  "motiv:mikroskop",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:veda",
        "fallback_key_1":  "motiv:veda",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "microscope",
                         "microscopy",
                         "laboratory"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zkumavka",
        "key":  "motiv:zkumavka",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:veda",
        "fallback_key_1":  "motiv:veda",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "laboratoř",
                         "chemie",
                         "test tube",
                         "laboratory",
                         "chemistry"
                     ],
        "filterable":  false
    },
    {
        "name":  "Chemická baňka",
        "key":  "motiv:chemicka-banka",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:veda",
        "fallback_key_1":  "motiv:veda",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "laboratorní baňka",
                         "chemie",
                         "flask",
                         "laboratory flask",
                         "chemistry flask"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mozek",
        "key":  "motiv:mozek",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:biologie-a-genetika",
        "fallback_key_1":  "motiv:biologie-a-genetika",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "brain",
                         "neuroscience",
                         "neurologie"
                     ],
        "filterable":  false
    },
    {
        "name":  "Srdce",
        "key":  "motiv:srdce-organ",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:biologie-a-genetika",
        "fallback_key_1":  "motiv:biologie-a-genetika",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "anatomické srdce",
                         "lidské srdce",
                         "anatomical heart",
                         "human heart"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zub",
        "key":  "motiv:zub",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:zdravotnictvi",
        "fallback_key_1":  "motiv:zdravotnictvi",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "zubař",
                         "zubařka",
                         "stomatologie",
                         "tooth",
                         "dentist",
                         "dentistry"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pilulka",
        "key":  "motiv:pilulka",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:zdravotnictvi",
        "fallback_key_1":  "motiv:zdravotnictvi",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "lék",
                         "tableta",
                         "pill",
                         "tablet",
                         "medicine"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lékárnička",
        "key":  "motiv:lekarnicka",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:zdravotnictvi",
        "fallback_key_1":  "motiv:zdravotnictvi",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "první pomoc",
                         "first aid kit",
                         "first aid",
                         "medical kit"
                     ],
        "filterable":  false
    },
    {
        "name":  "Teploměr",
        "key":  "motiv:teplomer",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:lekarske-nastroje",
        "fallback_key_1":  "motiv:lekarske-nastroje",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "thermometer",
                         "temperature"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lékař",
        "key":  "motiv:lekar",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "doktor",
                         "doktorka",
                         "lékařka",
                         "doctor",
                         "physician",
                         "medic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zdravotní sestra",
        "key":  "motiv:zdravotni-sestra",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "sestra",
                         "sestřička",
                         "zdravotník",
                         "zdravotnice",
                         "nurse",
                         "nursing"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hasič",
        "key":  "motiv:hasic",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "hasička",
                         "firefighter",
                         "fireman",
                         "firewoman"
                     ],
        "filterable":  false
    },
    {
        "name":  "Policista",
        "key":  "motiv:policista",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "policistka",
                         "policie",
                         "police officer",
                         "police",
                         "cop"
                     ],
        "filterable":  false
    },
    {
        "name":  "Učitel",
        "key":  "motiv:ucitel",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "učitelka",
                         "profesor",
                         "profesorka",
                         "teacher",
                         "educator"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kuchař",
        "key":  "motiv:kuchar",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "kuchařka",
                         "šéfkuchař",
                         "chef",
                         "cook"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kadeřník",
        "key":  "motiv:kadernik",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "kadeřnice",
                         "holič",
                         "hairdresser",
                         "hairstylist",
                         "barber"
                     ],
        "filterable":  false
    },
    {
        "name":  "Fotograf",
        "key":  "motiv:fotograf",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "fotografka",
                         "focení",
                         "photographer",
                         "photography"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vědec",
        "key":  "motiv:vedec",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "vědkyně",
                         "výzkumník",
                         "výzkumnice",
                         "scientist",
                         "researcher"
                     ],
        "filterable":  false
    },
    {
        "name":  "Umělec",
        "key":  "motiv:umelec",
        "group":  "main_motif",
        "overall_key":  "motiv:veda-a-povolani",
        "family_key":  "motiv:povolani",
        "fallback_key_1":  "motiv:povolani",
        "fallback_key_2":  "motiv:veda-a-povolani",
        "synonyms":  [
                         "umělkyně",
                         "výtvarník",
                         "výtvarnice",
                         "artist",
                         "creative"
                     ],
        "filterable":  false
    },
    {
        "name":  "Panna",
        "key":  "motiv:znameni-panna",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení panna",
                         "panna zvěrokruh",
                         "virgo",
                         "virgo sign",
                         "virgo zodiac",
                         "star sign virgo"
                     ],
        "filterable":  false
    },
    {
        "name":  "Lev",
        "key":  "motiv:znameni-lev",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení lev",
                         "lev zvěrokruh",
                         "leo",
                         "leo sign",
                         "leo zodiac",
                         "star sign leo"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vodnář",
        "key":  "motiv:znameni-vodnar",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení vodnář",
                         "vodnář zvěrokruh",
                         "aquarius",
                         "aquarius sign",
                         "aquarius zodiac",
                         "star sign aquarius"
                     ],
        "filterable":  false
    },
    {
        "name":  "Váhy",
        "key":  "motiv:znameni-vahy",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení váhy",
                         "váhy zvěrokruh",
                         "libra",
                         "libra sign",
                         "libra zodiac",
                         "star sign libra"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ryby",
        "key":  "motiv:znameni-ryby",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení ryby",
                         "ryby zvěrokruh",
                         "pisces",
                         "pisces sign",
                         "pisces zodiac",
                         "star sign pisces"
                     ],
        "filterable":  false
    },
    {
        "name":  "Býk",
        "key":  "motiv:znameni-byk",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení býk",
                         "býk zvěrokruh",
                         "taurus",
                         "taurus sign",
                         "taurus zodiac",
                         "star sign taurus"
                     ],
        "filterable":  false
    },
    {
        "name":  "Blíženci",
        "key":  "motiv:znameni-blizenci",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení blíženci",
                         "blíženci zvěrokruh",
                         "gemini",
                         "gemini sign",
                         "gemini zodiac",
                         "star sign gemini"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kozoroh",
        "key":  "motiv:znameni-kozoroh",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení kozoroh",
                         "kozoroh zvěrokruh",
                         "capricorn",
                         "capricorn sign",
                         "capricorn zodiac",
                         "star sign capricorn"
                     ],
        "filterable":  false
    },
    {
        "name":  "Rak",
        "key":  "motiv:znameni-rak",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení rak",
                         "rak zvěrokruh",
                         "cancer zodiac",
                         "cancer sign",
                         "star sign cancer"
                     ],
        "filterable":  false
    },
    {
        "name":  "Beran",
        "key":  "motiv:znameni-beran",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení beran",
                         "beran zvěrokruh",
                         "aries",
                         "aries sign",
                         "aries zodiac",
                         "star sign aries"
                     ],
        "filterable":  false
    },
    {
        "name":  "Střelec",
        "key":  "motiv:znameni-strelec",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení střelec",
                         "střelec zvěrokruh",
                         "sagittarius",
                         "sagittarius sign",
                         "sagittarius zodiac",
                         "star sign sagittarius"
                     ],
        "filterable":  false
    },
    {
        "name":  "Štír",
        "key":  "motiv:znameni-stir",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:znameni-zverokruhu",
        "fallback_key_1":  "motiv:znameni-zverokruhu",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "znamení štír",
                         "štír zvěrokruh",
                         "scorpio",
                         "scorpio sign",
                         "scorpio zodiac",
                         "star sign scorpio"
                     ],
        "filterable":  false
    },
    {
        "name":  "Srdce",
        "key":  "motiv:srdce",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "srdíčko",
                         "láska",
                         "zamilovaný",
                         "heart",
                         "hearts",
                         "love",
                         "romantic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Otevřené srdce",
        "key":  "motiv:otevrene-srdce",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "obrys srdce",
                         "srdce obrys",
                         "open heart",
                         "outline heart"
                     ],
        "filterable":  false
    },
    {
        "name":  "Půlené srdce",
        "key":  "motiv:pulene-srdce",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "půlka srdce",
                         "dvě poloviny srdce",
                         "přátelství",
                         "best friends",
                         "split heart",
                         "half heart",
                         "friendship heart"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zámek",
        "key":  "motiv:zamek",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "visací zámek",
                         "zámek lásky",
                         "lock",
                         "padlock",
                         "love lock"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klíč",
        "key":  "motiv:klic",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:klice-a-zamky",
        "fallback_key_1":  "motiv:klice-a-zamky",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "klíček",
                         "key",
                         "keys",
                         "key to my heart"
                     ],
        "filterable":  false
    },
    {
        "name":  "Spojené ruce",
        "key":  "motiv:spojene-ruce",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "",
        "fallback_key_1":  "motiv:astrologie-a-symboly",
        "fallback_key_2":  "",
        "synonyms":  [
                         "držení za ruce",
                         "ruce",
                         "přátelství",
                         "friendship",
                         "clasped hands",
                         "holding hands",
                         "togetherness"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kříž",
        "key":  "motiv:kriz",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:nabozenske-symboly",
        "fallback_key_1":  "motiv:nabozenske-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "křížek",
                         "křesťanský kříž",
                         "cross",
                         "christian cross",
                         "christianity"
                     ],
        "filterable":  false
    },
    {
        "name":  "Andělské číslo 11:11",
        "key":  "motiv:andelske-cislo-1111",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:astrologie",
        "fallback_key_1":  "motiv:astrologie",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "1111",
                         "11 11",
                         "jedenáct jedenáct",
                         "angel number 1111",
                         "angel number 11 11",
                         "make a wish"
                     ],
        "filterable":  false
    },
    {
        "name":  "Spirála",
        "key":  "motiv:spirala",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "spirálka",
                         "spiral",
                         "swirl"
                     ],
        "filterable":  false
    },
    {
        "name":  "Andělské číslo",
        "key":  "motiv:andelske-cislo",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:astrologie",
        "fallback_key_1":  "motiv:astrologie",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "andělská čísla",
                         "angel number",
                         "angel numbers",
                         "repeating numbers"
                     ],
        "filterable":  false
    },
    {
        "name":  "Anděl",
        "key":  "motiv:andel",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:astrologie",
        "fallback_key_1":  "motiv:astrologie",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "andílek",
                         "strážný anděl",
                         "angel",
                         "guardian angel"
                     ],
        "filterable":  false
    },
    {
        "name":  "Křídla",
        "key":  "motiv:kridla",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:astrologie",
        "fallback_key_1":  "motiv:astrologie",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "andělská křídla",
                         "křídlo",
                         "wings",
                         "wing",
                         "angel wings"
                     ],
        "filterable":  false
    },
    {
        "name":  "Nekonečno",
        "key":  "motiv:nekonecno",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "symbol nekonečna",
                         "věčnost",
                         "infinity",
                         "infinity symbol",
                         "forever",
                         "eternity"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jin jang",
        "key":  "motiv:jin-jang",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "jin a jang",
                         "yin yang",
                         "yin and yang",
                         "balance"
                     ],
        "filterable":  false
    },
    {
        "name":  "Oko",
        "key":  "motiv:oko",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:nabozenske-symboly",
        "fallback_key_1":  "motiv:nabozenske-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "oči",
                         "eye",
                         "eyes"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ochranné oko",
        "key":  "motiv:ochranne-oko",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:nabozenske-symboly",
        "fallback_key_1":  "motiv:nabozenske-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "zlé oko",
                         "modré oko",
                         "nazar",
                         "evil eye",
                         "protection eye",
                         "lucky eye"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hamsa",
        "key":  "motiv:hamsa",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:nabozenske-symboly",
        "fallback_key_1":  "motiv:nabozenske-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "ruka fatimy",
                         "fatimina ruka",
                         "hand of fatima",
                         "fatima hand",
                         "hamsa hand"
                     ],
        "filterable":  false
    },
    {
        "name":  "Podkova",
        "key":  "motiv:podkova",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:symboly-stesti",
        "fallback_key_1":  "motiv:symboly-stesti",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "štěstí",
                         "pro štěstí",
                         "horseshoe",
                         "lucky horseshoe",
                         "good luck"
                     ],
        "filterable":  false
    },
    {
        "name":  "Čtyřlístek",
        "key":  "motiv:ctyrlistek",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:symboly-stesti",
        "fallback_key_1":  "motiv:symboly-stesti",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "čtyřlístek pro štěstí",
                         "jetel",
                         "štěstí",
                         "four leaf clover",
                         "lucky clover",
                         "good luck"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mír",
        "key":  "motiv:mir",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "peace",
                         "peace and love"
                     ],
        "filterable":  false
    },
    {
        "name":  "Znak míru",
        "key":  "motiv:znak-miru",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "symbol míru",
                         "peace sign",
                         "peace symbol"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mandala",
        "key":  "motiv:mandala",
        "group":  "main_motif",
        "overall_key":  "motiv:astrologie-a-symboly",
        "family_key":  "motiv:geometricke-symboly",
        "fallback_key_1":  "motiv:geometricke-symboly",
        "fallback_key_2":  "motiv:astrologie-a-symboly",
        "synonyms":  [
                         "mandalový vzor",
                         "mandala symbol",
                         "mandala pattern"
                     ],
        "filterable":  false
    },
    {
        "name":  "Koruna",
        "key":  "motiv:koruna",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:kralovske-motivy",
        "fallback_key_1":  "motiv:kralovske-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "královská koruna",
                         "král",
                         "královna",
                         "crown",
                         "royal crown",
                         "king",
                         "queen"
                     ],
        "filterable":  false
    },
    {
        "name":  "Tiára",
        "key":  "motiv:tiara",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:kralovske-motivy",
        "fallback_key_1":  "motiv:kralovske-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "korunka",
                         "princezna",
                         "tiara",
                         "princess crown",
                         "princess"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zámek",
        "key":  "motiv:zamek-budova",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:kralovske-motivy",
        "fallback_key_1":  "motiv:kralovske-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "hrad",
                         "pohádkový zámek",
                         "castle",
                         "palace",
                         "fairytale castle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jednorožec",
        "key":  "motiv:jednorozec",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:pohadkove-motivy",
        "fallback_key_1":  "motiv:pohadkove-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "unicorn",
                         "unicorns",
                         "magical unicorn"
                     ],
        "filterable":  false
    },
    {
        "name":  "Drak",
        "key":  "motiv:drak",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:mytologie",
        "fallback_key_1":  "motiv:mytologie",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "dragon",
                         "dragons",
                         "mythical dragon"
                     ],
        "filterable":  false
    },
    {
        "name":  "Víla",
        "key":  "motiv:vila",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:pohadkove-motivy",
        "fallback_key_1":  "motiv:pohadkove-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "víla pohádková",
                         "fairy",
                         "fairies",
                         "pixie"
                     ],
        "filterable":  false
    },
    {
        "name":  "Mořská panna",
        "key":  "motiv:morska-panna",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:pohadkove-motivy",
        "fallback_key_1":  "motiv:pohadkove-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "siréna",
                         "mermaid",
                         "mermaids"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kouzelná hůlka",
        "key":  "motiv:kouzelna-hulka",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:pohadkove-motivy",
        "fallback_key_1":  "motiv:pohadkove-motivy",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "kouzelnická hůlka",
                         "hůlka",
                         "magic wand",
                         "magical wand",
                         "wizard wand"
                     ],
        "filterable":  false
    },
    {
        "name":  "Fénix",
        "key":  "motiv:fenix",
        "group":  "main_motif",
        "overall_key":  "motiv:fantazie",
        "family_key":  "motiv:mytologie",
        "fallback_key_1":  "motiv:mytologie",
        "fallback_key_2":  "motiv:fantazie",
        "synonyms":  [
                         "pták fénix",
                         "phoenix",
                         "phoenix bird",
                         "fire bird"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno",
        "key":  "motiv:pismeno",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmena",
                         "iniciála",
                         "iniciály",
                         "letter",
                         "letters",
                         "initial",
                         "initials"
                     ],
        "filterable":  false
    },
    {
        "name":  "Dopis",
        "key":  "motiv:dopis",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:dopisy-a-vzkazy",
        "fallback_key_1":  "motiv:dopisy-a-vzkazy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "psaníčko",
                         "milostný dopis",
                         "letter",
                         "love letter",
                         "handwritten letter"
                     ],
        "filterable":  false
    },
    {
        "name":  "Obálka",
        "key":  "motiv:obalka",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:dopisy-a-vzkazy",
        "fallback_key_1":  "motiv:dopisy-a-vzkazy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "dopisní obálka",
                         "obálka s dopisem",
                         "envelope",
                         "letter envelope",
                         "mail"
                     ],
        "filterable":  false
    },
    {
        "name":  "Nápis",
        "key":  "motiv:napis",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "text",
                         "slovo",
                         "slova",
                         "inscription",
                         "text",
                         "word",
                         "words"
                     ],
        "filterable":  false
    },
    {
        "name":  "OMG",
        "key":  "motiv:omg",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "oh my god",
                         "omg text",
                         "omg sign"
                     ],
        "filterable":  false
    },
    {
        "name":  "Číslo",
        "key":  "motiv:cislo",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "číslice",
                         "čísla",
                         "number",
                         "numbers",
                         "digit",
                         "digits"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hashtag",
        "key":  "motiv:hashtag",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "hash",
                         "mřížka",
                         "hashtag symbol",
                         "hash symbol"
                     ],
        "filterable":  false
    },
    {
        "name":  "Komiksová bublina",
        "key":  "motiv:bublina",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "bublina",
                         "řečová bublina",
                         "komiks",
                         "speech bubble",
                         "chat bubble",
                         "comic bubble"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vykřičník",
        "key":  "motiv:vykricnik",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "vykřičník symbol",
                         "exclamation mark",
                         "exclamation point"
                     ],
        "filterable":  false
    },
    {
        "name":  "Otazník",
        "key":  "motiv:otaznik",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "otazník symbol",
                         "question mark"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zavináč",
        "key":  "motiv:zavinac",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:slova-a-napisy",
        "fallback_key_1":  "motiv:slova-a-napisy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "at",
                         "at symbol",
                         "zavináč symbol",
                         "at sign"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hodiny",
        "key":  "motiv:hodiny",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:cas-a-hodiny",
        "fallback_key_1":  "motiv:cas-a-hodiny",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "hodiny na zeď",
                         "čas",
                         "clock",
                         "clocks",
                         "time"
                     ],
        "filterable":  false
    },
    {
        "name":  "Pistole",
        "key":  "motiv:pistole",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:zbrane",
        "fallback_key_1":  "motiv:zbrane",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "handgun",
                         "pistol",
                         "gun"
                     ],
        "filterable":  false
    },
    {
        "name":  "Přesýpací hodiny",
        "key":  "motiv:presypaci-hodiny",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:cas-a-hodiny",
        "fallback_key_1":  "motiv:cas-a-hodiny",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "přesýpačky",
                         "čas",
                         "hourglass",
                         "sand timer",
                         "sandglass"
                     ],
        "filterable":  false
    },
    {
        "name":  "Telefon",
        "key":  "motiv:telefon",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "mobil",
                         "mobilní telefon",
                         "smartphone",
                         "phone",
                         "mobile phone",
                         "cellphone"
                     ],
        "filterable":  false
    },
    {
        "name":  "Počítač",
        "key":  "motiv:pocitac",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "notebook",
                         "laptop",
                         "computer",
                         "pc"
                     ],
        "filterable":  false
    },
    {
        "name":  "Žárovka",
        "key":  "motiv:zarovka",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "světlo",
                         "nápad",
                         "inspirace",
                         "light bulb",
                         "lightbulb",
                         "idea",
                         "inspiration"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kotva",
        "key":  "motiv:ukotveni",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "kotva",
                         "ukotvení",
                         "anchor",
                         "grounding",
                         "stability"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zvonek",
        "key":  "motiv:zvonek",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "zvon",
                         "bell",
                         "bells"
                     ],
        "filterable":  false
    },
    {
        "name":  "Dárek",
        "key":  "motiv:darek",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "dáreček",
                         "dárek k narozeninám",
                         "gift",
                         "present",
                         "birthday gift"
                     ],
        "filterable":  false
    },
    {
        "name":  "Magnetofon",
        "key":  "motiv:magnetofon",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "kazetový přehrávač",
                         "tape recorder",
                         "cassette player",
                         "boombox"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kotva",
        "key":  "motiv:kotva",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:kazdodenni-predmety",
        "fallback_key_1":  "motiv:kazdodenni-predmety",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "kotvička",
                         "námořní kotva",
                         "anchor",
                         "nautical anchor"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kladivo",
        "key":  "motiv:kladivo",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:nastroje",
        "fallback_key_1":  "motiv:nastroje",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "hammer",
                         "tool"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klíč na matice",
        "key":  "motiv:klic-na-matice",
        "group":  "main_motif",
        "overall_key":  "motiv:predmety-a-technika",
        "family_key":  "motiv:nastroje",
        "fallback_key_1":  "motiv:nastroje",
        "fallback_key_2":  "motiv:predmety-a-technika",
        "synonyms":  [
                         "montážní klíč",
                         "francouzský klíč",
                         "nářadí",
                         "wrench",
                         "spanner",
                         "tool"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno A",
        "key":  "motiv:pismeno-a",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno a",
                         "iniciála a",
                         "letter a",
                         "initial a"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno B",
        "key":  "motiv:pismeno-b",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno b",
                         "iniciála b",
                         "letter b",
                         "initial b"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno C",
        "key":  "motiv:pismeno-c",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno c",
                         "iniciála c",
                         "letter c",
                         "initial c"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno D",
        "key":  "motiv:pismeno-d",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno d",
                         "iniciála d",
                         "letter d",
                         "initial d"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno E",
        "key":  "motiv:pismeno-e",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno e",
                         "iniciála e",
                         "letter e",
                         "initial e"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno F",
        "key":  "motiv:pismeno-f",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno f",
                         "iniciála f",
                         "letter f",
                         "initial f"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno G",
        "key":  "motiv:pismeno-g",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno g",
                         "iniciála g",
                         "letter g",
                         "initial g"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno H",
        "key":  "motiv:pismeno-h",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno h",
                         "iniciála h",
                         "letter h",
                         "initial h"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno I",
        "key":  "motiv:pismeno-i",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno i",
                         "iniciála i",
                         "letter i",
                         "initial i"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno J",
        "key":  "motiv:pismeno-j",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno j",
                         "iniciála j",
                         "letter j",
                         "initial j"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno K",
        "key":  "motiv:pismeno-k",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno k",
                         "iniciála k",
                         "letter k",
                         "initial k"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno L",
        "key":  "motiv:pismeno-l",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno l",
                         "iniciála l",
                         "letter l",
                         "initial l"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno M",
        "key":  "motiv:pismeno-m",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno m",
                         "iniciála m",
                         "letter m",
                         "initial m"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno N",
        "key":  "motiv:pismeno-n",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno n",
                         "iniciála n",
                         "letter n",
                         "initial n"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno O",
        "key":  "motiv:pismeno-o",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno o",
                         "iniciála o",
                         "letter o",
                         "initial o"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno P",
        "key":  "motiv:pismeno-p",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno p",
                         "iniciála p",
                         "letter p",
                         "initial p"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno Q",
        "key":  "motiv:pismeno-q",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno q",
                         "iniciála q",
                         "letter q",
                         "initial q"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno R",
        "key":  "motiv:pismeno-r",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno r",
                         "iniciála r",
                         "letter r",
                         "initial r"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno S",
        "key":  "motiv:pismeno-s",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno s",
                         "iniciála s",
                         "letter s",
                         "initial s"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno T",
        "key":  "motiv:pismeno-t",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno t",
                         "iniciála t",
                         "letter t",
                         "initial t"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno U",
        "key":  "motiv:pismeno-u",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno u",
                         "iniciála u",
                         "letter u",
                         "initial u"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno V",
        "key":  "motiv:pismeno-v",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno v",
                         "iniciála v",
                         "letter v",
                         "initial v"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno W",
        "key":  "motiv:pismeno-w",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno w",
                         "iniciála w",
                         "letter w",
                         "initial w"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno X",
        "key":  "motiv:pismeno-x",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno x",
                         "iniciála x",
                         "letter x",
                         "initial x"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno Y",
        "key":  "motiv:pismeno-y",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno y",
                         "iniciála y",
                         "letter y",
                         "initial y"
                     ],
        "filterable":  false
    },
    {
        "name":  "Písmeno Z",
        "key":  "motiv:pismeno-z",
        "group":  "main_motif",
        "overall_key":  "motiv:pismena-a-vzkazy",
        "family_key":  "motiv:pismena-a-inicialy",
        "fallback_key_1":  "motiv:pismena-a-inicialy",
        "fallback_key_2":  "motiv:pismena-a-vzkazy",
        "synonyms":  [
                         "písmeno z",
                         "iniciála z",
                         "letter z",
                         "initial z"
                     ],
        "filterable":  false
    },
    {
        "name":  "Láska",
        "key":  "tema:laska",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zamilovanost",
                         "romantika",
                         "partner",
                         "partnerka",
                         "přítel",
                         "přítelkyně",
                         "love",
                         "romance",
                         "romantic",
                         "boyfriend",
                         "girlfriend",
                         "partner"
                     ],
        "filterable":  false
    },
    {
        "name":  "Přátelství",
        "key":  "tema:pratelstvi",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "kamarád",
                         "kamarádka",
                         "nejlepší kamarádka",
                         "nejlepší kamarád",
                         "friendship",
                         "friend",
                         "friends",
                         "best friend",
                         "bestie"
                     ],
        "filterable":  false
    },
    {
        "name":  "Rodina",
        "key":  "tema:rodina",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "máma",
                         "maminka",
                         "táta",
                         "tatínek",
                         "sestra",
                         "bratr",
                         "rodinný",
                         "family",
                         "mother",
                         "mom",
                         "mum",
                         "father",
                         "dad",
                         "sister",
                         "brother"
                     ],
        "filterable":  false
    },
    {
        "name":  "Spojení",
        "key":  "tema:spojeni",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pouto",
                         "blízkost",
                         "společně",
                         "connection",
                         "bond",
                         "together",
                         "togetherness"
                     ],
        "filterable":  false
    },
    {
        "name":  "Radost",
        "key":  "tema:radost",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "veselost",
                         "šťastný",
                         "šťastná",
                         "joy",
                         "happiness",
                         "happy"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hravost",
        "key":  "tema:hravost",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hravý",
                         "hravá",
                         "zábavný",
                         "zábavná",
                         "playful",
                         "playfulness",
                         "fun"
                     ],
        "filterable":  false
    },
    {
        "name":  "Humor",
        "key":  "tema:humor",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vtip",
                         "vtipný",
                         "vtipná",
                         "legrace",
                         "humor",
                         "funny",
                         "joke"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sebevědomí",
        "key":  "tema:sebevedomi",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "sebejistota",
                         "sebevědomý",
                         "sebevědomá",
                         "confidence",
                         "confident",
                         "self confidence"
                     ],
        "filterable":  false
    },
    {
        "name":  "Individualita",
        "key":  "tema:individualita",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "jedinečnost",
                         "originální",
                         "osobitost",
                         "individuality",
                         "unique",
                         "uniqueness",
                         "original"
                     ],
        "filterable":  false
    },
    {
        "name":  "Sebevyjádření",
        "key":  "tema:sebevyjadreni",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vyjádřit sebe",
                         "osobní styl",
                         "self expression",
                         "express yourself",
                         "personal style"
                     ],
        "filterable":  false
    },
    {
        "name":  "Síla",
        "key":  "tema:sila",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "silný",
                         "silná",
                         "vnitřní síla",
                         "strength",
                         "strong",
                         "inner strength"
                     ],
        "filterable":  false
    },
    {
        "name":  "Odvaha",
        "key":  "tema:odvaha",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "statečnost",
                         "odvážný",
                         "odvážná",
                         "courage",
                         "brave",
                         "bravery"
                     ],
        "filterable":  false
    },
    {
        "name":  "Svoboda",
        "key":  "tema:svoboda",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "volnost",
                         "nezávislost",
                         "freedom",
                         "free",
                         "independence"
                     ],
        "filterable":  false
    },
    {
        "name":  "Dobrodružství",
        "key":  "tema:dobrodruzstvi",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "dobrodruh",
                         "dobrodružná",
                         "objevování",
                         "adventure",
                         "adventurous",
                         "exploring",
                         "exploration"
                     ],
        "filterable":  false
    },
    {
        "name":  "Kreativita",
        "key":  "tema:kreativita",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "tvoření",
                         "kreativní",
                         "tvorba",
                         "creativity",
                         "creative",
                         "creating"
                     ],
        "filterable":  false
    },
    {
        "name":  "Zvědavost",
        "key":  "tema:zvedavost",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zvídavost",
                         "zvědavý",
                         "zvědavá",
                         "curiosity",
                         "curious"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klid",
        "key":  "tema:klid",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pohoda",
                         "harmonie",
                         "relaxace",
                         "calm",
                         "peace",
                         "peaceful",
                         "relaxation",
                         "harmony"
                     ],
        "filterable":  false
    },
    {
        "name":  "Energie",
        "key":  "tema:energie",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "energický",
                         "energická",
                         "vitality",
                         "energy",
                         "energetic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Naděje",
        "key":  "tema:nadeje",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "víra v budoucnost",
                         "hope",
                         "hopeful"
                     ],
        "filterable":  false
    },
    {
        "name":  "Štěstí",
        "key":  "tema:stesti",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "pro štěstí",
                         "šťastný",
                         "šťastná",
                         "luck",
                         "lucky",
                         "good luck"
                     ],
        "filterable":  false
    },
    {
        "name":  "Ochrana",
        "key":  "tema:ochrana",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "ochranný",
                         "ochranná",
                         "bezpečí",
                         "protection",
                         "protective",
                         "safety"
                     ],
        "filterable":  false
    },
    {
        "name":  "Spiritualita",
        "key":  "tema:spiritualita",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "duchovno",
                         "duchovní",
                         "spiritualita",
                         "spirituality",
                         "spiritual"
                     ],
        "filterable":  false
    },
    {
        "name":  "Víra",
        "key":  "tema:vira",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "věřit",
                         "náboženství",
                         "faith",
                         "belief",
                         "religious"
                     ],
        "filterable":  false
    },
    {
        "name":  "Péče",
        "key":  "tema:pece",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "starostlivost",
                         "pečovat",
                         "care",
                         "caring",
                         "support"
                     ],
        "filterable":  false
    },
    {
        "name":  "Vzpomínky",
        "key":  "tema:vzpominky",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vzpomínka",
                         "památka",
                         "připomínka",
                         "memories",
                         "memory",
                         "keepsake",
                         "remembrance"
                     ],
        "filterable":  false
    },
    {
        "name":  "Nostalgie",
        "key":  "tema:nostalgie",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "retro",
                         "minulost",
                         "vzpomínání",
                         "nostalgia",
                         "nostalgic",
                         "retro"
                     ],
        "filterable":  false
    },
    {
        "name":  "Úspěch",
        "key":  "tema:uspech",
        "group":  "theme",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "vítězství",
                         "dosažení cíle",
                         "achievement",
                         "success",
                         "successful",
                         "victory"
                     ],
        "filterable":  false
    },
    {
        "name":  "Červená",
        "key":  "barva:cervena",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "cervena",
                         "red"
                     ],
        "filterable":  true
    },
    {
        "name":  "Zelená",
        "key":  "barva:zelena",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zelena",
                         "green"
                     ],
        "filterable":  true
    },
    {
        "name":  "Modrá",
        "key":  "barva:modra",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "modra",
                         "blue"
                     ],
        "filterable":  true
    },
    {
        "name":  "Fialová",
        "key":  "barva:fialova",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "fialova",
                         "purple",
                         "violet"
                     ],
        "filterable":  true
    },
    {
        "name":  "Růžová",
        "key":  "barva:ruzova",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "ruzova",
                         "pink"
                     ],
        "filterable":  true
    },
    {
        "name":  "Žlutá",
        "key":  "barva:zluta",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "zluta",
                         "yellow"
                     ],
        "filterable":  true
    },
    {
        "name":  "Bílá",
        "key":  "barva:bila",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "bila",
                         "white"
                     ],
        "filterable":  true
    },
    {
        "name":  "Béžová",
        "key":  "barva:bezova",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "bezova",
                         "beige"
                     ],
        "filterable":  true
    },
    {
        "name":  "Tyrkysová",
        "key":  "barva:tyrkysova",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "tyrkysova",
                         "turquoise"
                     ],
        "filterable":  true
    },
    {
        "name":  "Oranžová",
        "key":  "barva:oranzova",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "oranzova",
                         "orange"
                     ],
        "filterable":  true
    },
    {
        "name":  "Černá",
        "key":  "barva:cerna",
        "group":  "color",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "cerna",
                         "black"
                     ],
        "filterable":  true
    },
    {
        "name":  "Minimalistický",
        "key":  "styl:minimalisticky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "minimalismus",
                         "minimalist",
                         "minimalistic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Třpytivý",
        "key":  "styl:trpytivy",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "třpyt",
                         "sparkle",
                         "sparkly",
                         "glittery"
                     ],
        "filterable":  false
    },
    {
        "name":  "Hravý",
        "key":  "styl:hravy",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "hravost",
                         "playful"
                     ],
        "filterable":  false
    },
    {
        "name":  "Výrazný",
        "key":  "styl:vyrazny",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "výrazný šperk",
                         "bold",
                         "statement"
                     ],
        "filterable":  false
    },
    {
        "name":  "Roztomilý",
        "key":  "styl:roztomily",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "roztomilost",
                         "cute",
                         "adorable"
                     ],
        "filterable":  false
    },
    {
        "name":  "Barevný",
        "key":  "styl:barevny",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "barvy",
                         "colorful",
                         "colourful"
                     ],
        "filterable":  false
    },
    {
        "name":  "Symbolický",
        "key":  "styl:symbolicky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "symbolika",
                         "symbolic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Romantický",
        "key":  "styl:romanticky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "romantika",
                         "romantic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Detailní",
        "key":  "styl:detailni",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "detail",
                         "detailní zpracování",
                         "detailed",
                         "intricate"
                     ],
        "filterable":  false
    },
    {
        "name":  "Elegantní",
        "key":  "styl:elegantni",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "elegance",
                         "elegant"
                     ],
        "filterable":  false
    },
    {
        "name":  "Retro",
        "key":  "styl:retro",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "retro styl",
                         "retro style"
                     ],
        "filterable":  false
    },
    {
        "name":  "Jemný",
        "key":  "styl:jemny",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "jemnost",
                         "delicate",
                         "subtle"
                     ],
        "filterable":  false
    },
    {
        "name":  "Surrealistický",
        "key":  "styl:surrealisticky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "surrealismus",
                         "surreal",
                         "surrealistic"
                     ],
        "filterable":  false
    },
    {
        "name":  "Boho",
        "key":  "styl:boho",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "bohémský",
                         "bohemian"
                     ],
        "filterable":  false
    },
    {
        "name":  "Moderní",
        "key":  "styl:moderni",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "moderní styl",
                         "modern",
                         "contemporary"
                     ],
        "filterable":  false
    },
    {
        "name":  "Rebelský",
        "key":  "styl:rebelsky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "rebel",
                         "rebellious"
                     ],
        "filterable":  false
    },
    {
        "name":  "Klasický",
        "key":  "styl:klasicky",
        "group":  "style",
        "overall_key":  "",
        "family_key":  "",
        "fallback_key_1":  "",
        "fallback_key_2":  "",
        "synonyms":  [
                         "klasika",
                         "classic"
                     ],
        "filterable":  false
    }
];
